// File generated by salient-types.
// @ts-nocheck
export enum InputMode {
    NONE = 0,
    SERVO = 1,
    CAN = 2,
    USB = 3,
    ETHERNET = 4,
}

export enum ControlMode {
    TORQUE = 0,
    SPEED = 1,
    VOLTAGE = 2,
    POSITION = 3,
}

export enum ControllerState {
    BOOT = 0,
    CALIBRATION = 1,
    L_R_DETECTION = 2,
    ENCODER_DETECTION = 3,
    STOPPED = 4,
    RUNNING = 5,
    TEST = 6,
    UPDATING_FIRMWARE = 7,
    FAULT = 8,
    HALL_SENSOR_DETECTION = 9,
}

export enum FaultCode {
    NO_FAULT = 0,
    BAD_CALIBRATION_CURRENT_MEASURE = 1,
    VOLTAGE_OUT_OF_RANGE_CRITICAL = 2,
    OVERTEMPERATURE = 3,
    OVERCURRENT_CRITICAL = 4,
    BAD_CONFIG = 5,
    GATE_DRIVE_UNDERVOLTAGE = 6,
    LOGIC_UNDERVOLTAGE_Deprecated = 7,
    PARAM_DETECT_FAIL = 8,
    NAN_OUTPUT_PHASE_VOLTAGE = 9,
    BAD_PARAM_Deprecated = 10,
    INPUT_TIMEOUT_Deprecated = 11,
    ENCODER_CALIBRATION_FAILED = 12,
    GATE_DRIVE_OVERCURRENT = 13,
    GATE_DRIVE_FAULT = 14,
    GATE_DRIVE_OVERTEMPERATURE_SHUTDOWN = 15,
    GATE_DRIVE_OVERTEMPERATURE_WARNING = 16,
    GATE_DRIVE_CHARGE_PUMP_VGLS_UNDERVOLTAGE = 17,
    GATE_DRIVE_INIT_FAILED = 18,
    HALL_SENSOR_CALIBRATION_FAILED = 19,
    VOLTAGE_OUT_OF_RANGE_WARNING = 20,
    OVERCURRENT_WARNING = 21,
    OVERLOAD_CRITICAL = 22,
    DC_OVERCURRENT_CRITICAL = 23,
    NULL_KEYSTORE_CALLBACK = 24,
    CRC_32_MISMATCH = 25,
    RESOLVER_DOS = 26,
    RESOLVER_LOT = 27,
    RESOLVER_SPI_COMM = 28,
    LVDT_SPI_COMM = 29,
    AUTOTUNE_EARLY_EXIT = 30,
    MOTOR_OVERTEMPERATURE_CRITICAL = 31,
    READOUT_PROTECTION_FAILED = 32,
    ETHERNET_INIT_FAILED = 33,
    ETHERNET_PHY_BIST_FAILED = 34,
    DARE_SENSOR_FAULT = 35,
}

export enum SensorMode {
    SENSORLESS = 0,
    ENCODER = 1,
    OPENLOOP = 2,
    HALLSENSOR = 3,
    ABSOLUTE_ENCODER = 4,
    RESOLVER = 5,
}

export enum SensorCalibStatus {
    UNKNOWN = 0,
    COMPLETE = 1,
    ONGOING = 2,
    FAILURE_INDEX_MISSING = 3,
    FAILURE_POSITION_ERROR = 4,
    FAILURE_TIMEOUT = 5,
    FAILURE_ABORTED = 6,
    ONGOING_SETTLING = 7,
    ONGOING_SAMPLING = 8,
    ONGOING_COMPUTING = 9,
}

export enum HomingCalibStatus {
    UNKNOWN = 0,
    SUCCESS = 1,
    IN_PROGRESS = 2,
    FAILURE_TIMEOUT = 3,
    FAILURE_NO_STALL = 4,
    FAILURE_NOT_FREEWHEEL = 5,
}

export enum SmFwBuildType {
    EXPERIMENTAL = 0,
    CANDIDATE = 1,
    RELEASE = 2,
}

export enum SeatState {
    IDLE = 0,
    MOVE_TOL = 1,
    MOVE_BED = 2,
    BACKREST_UP = 3,
    BACKREST_DN = 4,
    TRANS_UP = 5,
    TRANS_DN = 6,
    LUMBAR_INF = 7,
    LUMBAR_DEF = 8,
    INVALID = 9,
}

export enum SeatAction {
    STOP = 0,
    PRESET_TTL = 1,
    PRESET_BED = 2,
    BACKREST_UP = 3,
    BACKREST_DN = 4,
    TRACK_FWD = 5,
    TRACK_BWD = 6,
    LUMBAR_INF = 7,
    LUMBAR_DEF = 8,
    CLEAR_FAULTS = 9,
}

export enum GearRatioCalStatus {
    IDLE = 0,
    RUNNING = 1,
    COMPLETE = 2,
    FAILED_TIMEOUT = 3,
    FAILED_NO_MOTION = 4,
    FAILED_LOW_QUALITY = 5,
}

export enum CapabilityId {
    TELEMETRY = 0,
    LOGGING = 1,
}

export enum AutotuneCommand {
    START = 0,
    NEXT_PHASE = 1,
    RETRY_PHASE = 2,
    RETUNE_GAINS = 3,
    STOP = 4,
}

export enum AutotuneStatus {
    IDLE = 0,
    RUNNING = 1,
    WAITING_USER = 2,
    COMPLETE = 3,
    FAILED = 4,
}

export enum AutotunePhase {
    IDLE = 0,
    BOOTSTRAP_GAINS = 1,
    ID_B = 2,
    ID_J = 3,
    TUNE_SPEED = 4,
    TUNE_POSITION = 5,
    COMPLETE = 6,
    FAILED = 7,
}

export enum AutotuneError {
    NONE = 0,
    SAFETY_LIMIT = 1,
    TIMEOUT = 2,
    INVALID_DATA = 3,
    OSCILLATION = 4,
    SATURATION = 5,
    ENCODER = 6,
    ABORTED = 7,
    NOT_CONFIGURED = 8,
    MOTOR_SPINNING = 9,
    INSUFFICIENT_TRAVEL = 10,
    INVALID_MOTOR = 11,
}

export enum AutotuneExitReason {
    NONE = 0,
    TIMEOUT = 1,
    SAFETY = 2,
    COMPLETE = 3,
    FAILED = 4,
    EARLY_EXIT_RUNNING = 5,
}

export enum AutotuneIdJFailReason {
    NONE = 0,
    ALL_INVALID = 1,
    HIGH_SCATTER = 2,
    MEDIAN_INVALID = 3,
}

export enum AutotuneIdBFailReason {
    NONE = 0,
    ZERO_VALID_POINTS = 1,
    B_NOT_FINITE = 2,
    TORQUE_LIMIT_ALL_POINTS = 3,
    ALL_POINTS_LOW_SPEED = 4,
}
export enum AbsoluteEncoderDirection {
    COUNT_DOWN = -1,
    UNKNOWN = 0,
    COUNT_UP = 1,
}

export enum EncoderDirection {
    COUNT_DOWN = -1,
    UNKNOWN = 0,
    COUNT_UP = 1,
}

export enum HallsensorDirection {
    REVERSE = -1,
    UNKNOWN = 0,
    FORWARD = 1,
}

export enum ResolverDirection {
    REVERSE = -1,
    UNKNOWN = 0,
    FORWARD = 1,
}

export enum FluxWeakening {
    UNKNOWN = -1,
    DISABLE = 0,
    ENABLE = 1,
}

export enum Mtpa {
    UNKNOWN = -1,
    DISABLE = 0,
    ENABLE = 1,
}

export enum PositionType {
    UNKNOWN = -1,
    ROTATIONAL = 0,
    LINEAR = 1,
}

export enum PositionUnits {
    UNKNOWN = -1,
    RADIANS = 0,
    DEGREES = 1,
    MILLIMETERS = 2,
    INCHES = 3,
}

export enum PositionResolution {
    UNKNOWN = -1,
    VALUE_1E0 = 0,
    VALUE_1E1 = 1,
    VALUE_1E2 = 2,
    VALUE_1E3 = 3,
}

export enum CertExchangeResult {
    SUCCESS = 0,
    BAD_CHALLENGE_STEP = 1,
    KEY_NOT_FOUND = 2,
    BAD_SIGNATURE = 3,
}

export enum EncChallengeResult {
    SUCCESS = 0,
    BAD_CHALLENGE_STEP = 1,
    BAD_DECRYPTION = 2,
}

export enum AuthStatus {
    AUTHENTICATED = 0,
    NEEDS_REAUTH = 1,
}

export enum SacsActuatorNodeId {
    S1_BACKREST = 2,
    S1_TRACK = 3,
    CENTER = 4,
    S2_BACKREST = 18,
    S2_TRACK = 19,
}

export enum CanopenErrorCode {
    DEPRECATED = 65281,
    BAD_CALIBRATION_CURRENT_MEASURE = 65282,
    GATE_DRIVE_UNDERVOLTAGE = 65283,
    ENCODER_CALIBRATION_FAILED = 65284,
    INPUT_TIMEOUT = 65285,
    GATE_DRIVE_FAULT = 65286,
    GATE_DRIVE_OVERTEMPERATURE_SHUTDOWN = 65287,
    GATE_DRIVE_OVERTEMPERATURE_WARNING = 65288,
    GATE_DRIVE_CHARGE_PUMP_UNDERVOLTAGE = 65289,
    GATE_DRIVE_INIT_FAILED = 65290,
    CRITICAL_OVERLOAD = 65291,
    OUT_OF_WINDOW_VOLTAGE_WARNING = 65292,
    OUT_OF_WINDOW_VOLTAGE_CRITICAL = 65293,
    OVERCURRENT_WARNING = 65294,
    BAD_CONFIGURATION = 65295,
    GATE_DRIVE_OVERCURRENT = 65296,
    OVERCURRENT_CRITICAL = 65297,
    NAN_OUTPUT_PHASE_VOLTAGE = 65298,
    PARAM_DETECT_FAIL = 65299,
    HALL_SENSOR_CALIBRATION_FAILED = 65300,
}

export enum PacketId {
    INVALID = 0,
    HANDSHAKE = 1,
    START_PARAM_DETECT = 2,
    WRITE_INPUT_CONFIG = 3,
    WRITE_POWER_CONFIG = 4,
    READ_FAULT = 5,
    READ_TELEMETRY = 6,
    READ_MOTOR_PARAM = 7,
    READ_INPUT_CONFIG = 8,
    READ_POWER_CONFIG = 9,
    WRITE_PARAMETERS = 10,
    WRITE_CONTROL_CONFIG = 11,
    WRITE_SENSOR_MODE = 12,
    READ_SENSOR_MODE = 13,
    START_ENCODER_CAL = 14,
    GET_ENCODER_CAL_RESULT = 15,
    ENCODER_CAL_RESULT = 16,
    WRITE_OPEN_LOOP_CONFIG = 17,
    READ_CONTROL_MODE = 18,
    WRITE_CAN_ID = 19,
    READ_CAN_ID = 20,
    WRITE_ESC_ID = 21,
    READ_ESC_ID = 22,
    GET_BUILD_INFO = 23,
    READ_MTPA_STATUS = 24,
    READ_FLUX_WEAKENING_STATUS = 25,
    WRITE_POSITION_CONTROL_SETTINGS = 26,
    READ_POSITION_CONTROL_SETTINGS = 27,
    SET_POSITION_SENSOR_LIMITS = 28,
    READ_POSITION_SENSOR_LIMITS = 29,
    START_HALL_SENSOR_CAL = 30,
    GET_HALL_SENSOR_CAL_RESULT = 31,
    HALL_SENSOR_CAL_RESULT = 32,
    CLEAR_ALL_FAULTS = 33,
    CERT_EXCHANGE_1 = 34,
    CERT_EXCHANGE_2 = 35,
    ENC_CHALLENGE_1 = 36,
    ENC_CHALLENGE_2 = 37,
    KEEP_ALIVE = 38,
    KEY_CONFIG = 39,
    START_HOMING_CAL = 40,
    HOMING_CAL_RESULT = 41,
    START_SYSID = 42,
    STOP_SYSID = 43,
    ZERO_DARE_SENSOR = 44,
    READ_TOTAL_ACTUATORS = 45,
    ACTUATOR_INFO = 46,
    SET_CONTROL_MODE = 47,
    ENABLE_BULK_TELEMETRY = 48,
    SET_TELEM_RATE = 49,
    GET_CAPABILITIES = 50,
    AUTOTUNE_CONTROL = 51,
    GET_AUTOTUNE_STATUS = 52,
    SET_AUTOTUNE_CONFIG = 53,
    GET_AUTOTUNE_PARAMS = 54,
    GET_SENSOR_CAL_STATUS = 55,
    SET_SEAT_MOTION = 56,
    DEVICE_LOGS = 57,
    SET_USB_THROTTLE_CONTROL = 64,
    FAULT_DATA = 127,
    REALTIME_DATA = 128,
    VARIABLE_TELEMETRY = 129,
    MULTI_MOTOR_TELEMETRY = 130,
    FIRMWARE_UPDATE = 254,
    USER_DEFINED = 255,
}

export interface IInvalidRequest {
}

export interface IInvalidResponse {
}

export interface IHandshakeRequest {
}

export interface IHandshakeResponse {
    versionMajor: number;
    versionMinor: number;
    versionBuild: number;
    resistance: number;
    ld: number;
    lq: number;
    fluxLinkage: number;
    gitHash: number;
    deviceId1: number;
    deviceId2: number;
    deviceId3: number;
}

export interface IStartParamDetectRequest {
    paramDetectMaxCurrent: number;
    paramDetectMaxRpm: number;
    motorIndex: number;
}

export interface IStartParamDetectResponse {
    resistance: number;
    ld: number;
    lq: number;
    fluxLinkage: number;
}

export interface IWriteInputConfigRequest {
    inputLimitUpper: number;
    inputLimitLower: number;
    inputLimitCenter: number;
    inputMode: InputMode;
    alwaysOn: number;
}

export interface IWriteInputConfigResponse {
    inputLimitUpper: number;
    inputLimitLower: number;
    inputLimitCenter: number;
    inputMode: InputMode;
    alwaysOn: number;
}

export interface IWritePowerConfigRequest {
    motorCurrentLimit: number;
    batteryCurrentLimit: number;
    criticalOvervoltageThreshold: number;
    criticalUndervoltageThreshold: number;
    overcurrentThresholdDeprecated: number;
    overtemperatureThreshold: number;
    warningOvervoltageThreshold: number;
    warningUndervoltageThreshold: number;
    warningMotorCurrentThreshold: number;
    criticalMotorCurrentThreshold: number;
}

export interface IWritePowerConfigResponse {
    motorCurrentLimit: number;
    batteryCurrentLimit: number;
    criticalOvervoltageThreshold: number;
    criticalUndervoltageThreshold: number;
    overcurrentThresholdDeprecated: number;
    overtemperatureThreshold: number;
    warningOvervoltageThreshold: number;
    warningUndervoltageThreshold: number;
    warningMotorCurrentThreshold: number;
    criticalMotorCurrentThreshold: number;
}

export interface IReadFaultRequest {
}

export interface IReadFaultResponse {
}

export interface IReadTelemetryRequest {
}

export interface IReadTelemetryResponse {
}

export interface IReadMotorParamRequest {
}

export interface IReadMotorParamResponse {
}

export interface IReadInputConfigRequest {
}

export interface IReadInputConfigResponse {
    inputLimitUpper: number;
    inputLimitLower: number;
    inputLimitCenter: number;
    inputMode: InputMode;
    alwaysOn: number;
}

export interface IReadPowerConfigRequest {
}

export interface IReadPowerConfigResponse {
    motorCurrentLimit: number;
    batteryCurrentLimit: number;
    criticalOvervoltageThreshold: number;
    criticalUndervoltageThreshold: number;
    overcurrentThresholdDeprecated: number;
    overtemperatureThreshold: number;
    warningOvervoltageThreshold: number;
    warningUndervoltageThreshold: number;
    warningMotorCurrentThreshold: number;
    criticalMotorCurrentThreshold: number;
}

export interface IWriteParametersRequest {
    resistance: number;
    ld: number;
    lq: number;
    fluxLinkage: number;
}

export interface IWriteParametersResponse {
    resistance: number;
    ld: number;
    lq: number;
    fluxLinkage: number;
}

export interface IWriteControlConfigRequest {
    motorMaxSpeed: number;
    polePairCount: number;
    speedControlProportionalGain: number;
    speedControlIntegralGain: number;
    deprecatedPositionControlProportionalGain: number;
    controlMode: ControlMode;
    mtpa: Mtpa;
    fluxWeakening: FluxWeakening;
}

export interface IWriteControlConfigResponse {
    motorMaxSpeed: number;
    polePairCount: number;
    speedControlProportionalGain: number;
    speedControlIntegralGain: number;
    deprecatedPositionControlProportionalGain: number;
    controlMode: ControlMode;
    mtpa: Mtpa;
    fluxWeakening: FluxWeakening;
}

export interface IWriteSensorModeRequest {
    sensorMode: SensorMode;
    encoderCpr: number;
}

export interface IWriteSensorModeResponse {
    sensorMode: SensorMode;
    encoderCpr: number;
}

export interface IReadSensorModeRequest {
}

export interface IReadSensorModeResponse {
    sensorMode: SensorMode;
    encoderCpr: number;
    encoderOffset: number;
    encoderDirection: EncoderDirection;
    hallsensorForwardOffset: number;
    hallsensorReverseOffset: number;
    hallsensorDirection: HallsensorDirection;
}

export interface IStartEncoderCalRequest {
    motorIndex: number;
}

export interface IStartEncoderCalResponse {
}

export interface IGetEncoderCalResultRequest {
}

export interface IGetEncoderCalResultResponse {
    offset: number;
    status: SensorCalibStatus;
    direction: EncoderDirection;
}

export interface IEncoderCalResultRequest {
}

export interface IEncoderCalResultResponse {
    offset: number;
    status: SensorCalibStatus;
    direction: EncoderDirection;
}

export interface IWriteOpenLoopConfigRequest {
    accelerationRamp: number;
}

export interface IWriteOpenLoopConfigResponse {
    accelerationRamp: number;
}

export interface IReadControlModeRequest {
}

export interface IReadControlModeResponse {
    controlMode: ControlMode;
}

export interface IWriteCanIdRequest {
    canId: number;
}

export interface IWriteCanIdResponse {
    canId: number;
}

export interface IReadCanIdRequest {
}

export interface IReadCanIdResponse {
    canId: number;
}

export interface IWriteEscIdRequest {
    escIndex: number;
}

export interface IWriteEscIdResponse {
    escIndex: number;
}

export interface IReadEscIdRequest {
}

export interface IReadEscIdResponse {
    escIndex: number;
}

export interface IGetBuildInfoRequest {
}

export interface IGetBuildInfoResponse {
    year: number;
    month: number;
    day: number;
    increment: number;
    buildType: SmFwBuildType;
    dirty: number;
}

export interface IReadMtpaStatusRequest {
}

export interface IReadMtpaStatusResponse {
    mtpa: Mtpa;
}

export interface IReadFluxWeakeningStatusRequest {
}

export interface IReadFluxWeakeningStatusResponse {
    fluxWeakening: FluxWeakening;
}

export interface IWritePositionControlSettingsRequest {
    positionControlProportionalGain: number;
    positionControlIntegralGain: number;
    positionControlDerivGain: number;
    positionControlMaxSpeed: number;
    positionControlMaxAccel: number;
    positionControlDeadband: number;
    positionControlType: PositionType;
    positionUnits: PositionUnits;
    positionResolution: PositionResolution;
    travelDistance: number;
    softStopRangePercent: number;
}

export interface IWritePositionControlSettingsResponse {
    positionControlProportionalGain: number;
    positionControlIntegralGain: number;
    positionControlDerivGain: number;
    positionControlMaxSpeed: number;
    positionControlMaxAccel: number;
    positionControlDeadband: number;
    positionControlType: PositionType;
    positionUnits: PositionUnits;
    positionResolution: PositionResolution;
    travelDistance: number;
    softStopRangePercent: number;
}

export interface IReadPositionControlSettingsRequest {
}

export interface IReadPositionControlSettingsResponse {
    positionControlProportionalGain: number;
    positionControlIntegralGain: number;
    positionControlDerivGain: number;
    positionControlMaxSpeed: number;
    positionControlMaxAccel: number;
    positionControlDeadband: number;
    positionControlType: PositionType;
    positionUnits: PositionUnits;
    positionResolution: PositionResolution;
    travelDistance: number;
    softStopRangePercent: number;
}

export interface ISetPositionSensorLimitsRequest {
    setCurrentPosToMin: number;
    setCurrentPosToMax: number;
    motorIndex: number;
}

export interface ISetPositionSensorLimitsResponse {
    minPosition: number;
    maxPosition: number;
}

export interface IReadPositionSensorLimitsRequest {
}

export interface IReadPositionSensorLimitsResponse {
    minValue: number;
    maxValue: number;
}

export interface IStartHallSensorCalRequest {
    motorIndex: number;
}

export interface IStartHallSensorCalResponse {
}

export interface IGetHallSensorCalResultRequest {
}

export interface IGetHallSensorCalResultResponse {
    forwardOffset: number;
    reverseOffset: number;
    status: SensorCalibStatus;
    direction: HallsensorDirection;
}

export interface IHallSensorCalResultRequest {
}

export interface IHallSensorCalResultResponse {
    forwardOffset: number;
    reverseOffset: number;
    status: SensorCalibStatus;
    direction: HallsensorDirection;
}

export interface IClearAllFaultsRequest {
}

export interface IClearAllFaultsResponse {
}

export interface ICertExchange1Request {
    sLabCertFirstHalf: Uint8Array | number[]; // 50 bytes
}

export interface ICertExchange1Response {
    mcuCertFirstHalf: Uint8Array | number[]; // 50 bytes
}

export interface ICertExchange2Request {
    sLabCertLastHalf: Uint8Array | number[]; // 50 bytes
}

export interface ICertExchange2Response {
    result: CertExchangeResult;
    mcuCertLastHalf: Uint8Array | number[]; // 50 bytes
}

export interface IEncChallenge1Request {
    challengeA: Uint8Array | number[]; // 16 bytes
}

export interface IEncChallenge1Response {
    encChallengeA: Uint8Array | number[]; // 16 bytes
    challengeB: Uint8Array | number[]; // 16 bytes
}

export interface IEncChallenge2Request {
    encChallengeB: Uint8Array | number[]; // 16 bytes
}

export interface IEncChallenge2Response {
    result: EncChallengeResult;
}

export interface IKeepAliveRequest {
}

export interface IKeepAliveResponse {
    authStatus: AuthStatus;
}

export interface IKeyConfigRequest {
    keyBytestream: Uint8Array | number[]; // 60 bytes
}

export interface IKeyConfigResponse {
    keyBytestreamRsp: Uint8Array | number[]; // 60 bytes
}

export interface IStartHomingCalRequest {
}

export interface IStartHomingCalResponse {
}

export interface IHomingCalResultRequest {
}

export interface IHomingCalResultResponse {
    zeroOffset: number;
    status: HomingCalibStatus;
}

export interface IStartSysidRequest {
    motorIndex: number;
}

export interface IStartSysidResponse {
}

export interface IStopSysidRequest {
}

export interface IStopSysidResponse {
}

export interface IZeroDareSensorRequest {
}

export interface IZeroDareSensorResponse {
    encoder0ZeroPos: number;
    encoder1ZeroPos: number;
}

export interface IReadTotalActuatorsRequest {
}

export interface IReadTotalActuatorsResponse {
    detectedNodes: number;
    expectedNodes: number;
    operationalNodesBitmap: number;
}

export interface IActuatorInfoRequest {
}

export interface IActuatorInfoResponse {
    nodeId: number;
    dispositionStr: Uint8Array | number[]; // 27 bytes
}

export interface ISetControlModeRequest {
    controlMode: ControlMode;
}

export interface ISetControlModeResponse {
    controlMode: ControlMode;
}

export interface IEnableBulkTelemetryRequest {
    enable: number;
}

export interface IEnableBulkTelemetryResponse {
    enabled: number;
}

export interface ISetTelemRateRequest {
    requestedHz: number;
}

export interface ISetTelemRateResponse {
    achievedHz: number;
}

export interface IGetCapabilitiesRequest {
}

export interface IGetCapabilitiesResponse {
    count: number;
    entries: Uint8Array | number[]; // 59 bytes
}

export interface IAutotuneControlRequest {
    motorIndex: number;
    command: AutotuneCommand;
    targetPhase: number;
}

export interface IAutotuneControlResponse {
    motorIndex: number;
    status: AutotuneStatus;
    currentPhase: AutotunePhase;
    errorCode: AutotuneError;
    xHalfSafeRad: number;
    wFeasibleRadps: number;
    alphaBrakeRadps2: number;
    jAssumedKgm2: number;
}

export interface IGetAutotuneStatusRequest {
    motorIndex: number;
}

export interface IGetAutotuneStatusResponse {
    motorIndex: number;
    status: AutotuneStatus;
    phase: AutotunePhase;
    phaseProgress: number;
    errorCode: AutotuneError;
    currentSpeedRadps: number;
    currentTorqueNm: number;
    currentPositionRad: number;
    commandedSpeedRadps: number;
    commandedTorqueNm: number;
    identifiedJKgm2: number;
    identifiedBNmsrad: number;
    speedKp: number;
    speedKi: number;
    positionKp: number;
    lastExitNextState: number;
    lastExitReason: AutotuneExitReason;
    lastExitPhase: AutotunePhase;
    lastExitError: AutotuneError;
    lastExitTimeMs: number;
    safetyTripFlags: number;
    idJFailReason: AutotuneIdJFailReason;
    jLatestTrialKgm2: number;
    idBFailReason: AutotuneIdBFailReason;
}

export interface ISetAutotuneConfigRequest {
    motorIndex: number;
    maxCurrentA: number;
    maxSpeedRadps: number;
    maxAccelRadps2: number;
    positionWindowRad: number;
    speedBandwidthHz: number;
    disturbanceRejectDb: number;
    phaseMarginDeg: number;
    positionBandwidthHz: number;
    gearRatio: number;
    ktNma: number;
    polePairs: number;
    zeroPlacementDivisor: number;
    bootstrapRateLevel: number;
    bootstrapMaxSpeedRadps: number;
    skipBootstrap: number;
}

export interface ISetAutotuneConfigResponse {
    motorIndex: number;
    status: number;
}

export interface IGetAutotuneParamsRequest {
    motorIndex: number;
}

export interface IGetAutotuneParamsResponse {
    motorIndex: number;
    inertiaKgm2: number;
    viscousFrictionNms: number;
    coulombFrictionNm: number;
    staticFrictionNm: number;
    speedKp: number;
    speedKi: number;
    positionKp: number;
    positionKi: number;
    speedBandwidthHz: number;
    speedPhaseMarginDeg: number;
    speedSettlingTimeMs: number;
    speedOvershootPct: number;
    positionBandwidthHz: number;
    positionSettlingTimeMs: number;
}

export interface IGetSensorCalStatusRequest {
    motorIndex: number;
}

export interface IGetSensorCalStatusResponse {
    motorIndex: number;
    calStatus: SensorCalibStatus;
    sampleCount: number;
    meanAngleErrorDeg: number;
    stddevAngleErrorDeg: number;
    sensorNoiseMeanDeg: number;
    sensorNoiseStddevDeg: number;
    dAxisOffsetRad: number;
    lastAngleErrorDeg: number;
}

export interface ISetSeatMotionRequest {
    seat: number;
    action: SeatAction;
}

export interface ISetSeatMotionResponse {
    seat: number;
    action: SeatAction;
    accepted: number;
    state: SeatState;
}

export interface IDeviceLogsRequest {
    recordOffset: number;
    recordCount: number;
}

export interface IDeviceLogsResponse {
    recordNumber: number;
    msgSegment: Uint8Array | number[]; // 56 bytes
}

export interface ISetUsbThrottleControlRequest {
    value: number;
    motorIndex: number;
}

export interface ISetUsbThrottleControlResponse {
    value: number;
    motorIndex: number;
}

export interface IFaultDataMessage {
    code: number;
}

export interface IRealtimeDataMessage {
    motorSpeed: number;
    motorCurrent: number;
    batteryVoltage: number;
    batteryCurrent: number;
    servoPulse: number;
    inverterTemp: number;
    controllerState: ControllerState;
    faultCodeDeprecated: FaultCode;
    uptimeMs: number;
    motorPosition: number;
    positionSensorReading: number;
    faultsBitmapLower32: number;
    faultsBitmapUpper16: number;
    externalThermTemp: number;
    rawPositionSensor: number;
    sysidFrequency: number;
    sysidMagnitude: number;
}

export interface IVariableTelemetryMessage {
    telemId: number;
    telemBytestream: Uint8Array | number[]; // 59 bytes
}

export interface IMultiMotorTelemetryMessage {
    actuatorNodeId: number;
    faultsBitmapLower32: number;
    faultsBitmapUpper16: number;
    positionActualPctOfRange: number;
    velocityActualValue: number;
    torqueActualValue: number;
    electricalCurrentActualValue: number;
    targetPositionPctOfRange: number;
    statusWord: number;
    mosfetTemperature: number;
    batteryCurrent: number;
    motorCurrent: number;
    motorTemperature: number;
    positionActualValue: number;
    positionSensorRawValue: number;
    positionUserUnits: number;
}

export interface IFirmwareUpdateRequest {
}

export interface IFirmwareUpdateResponse {
}

export interface IUserDefinedMessage {
}

export const serializeInvalidRequest = ( message: IInvalidRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.INVALID );
    return dv;
};

export const serializeInvalidResponse = ( message: IInvalidResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.INVALID );
    return dv;
};

export const serializeHandshakeRequest = ( message: IHandshakeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HANDSHAKE );
    return dv;
};

export const serializeHandshakeResponse = ( message: IHandshakeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HANDSHAKE );
    dv.setUint32( 4, message.versionMajor, true );
    dv.setUint32( 8, message.versionMinor, true );
    dv.setUint32( 12, message.versionBuild, true );
    dv.setFloat32( 16, message.resistance, true );
    dv.setFloat32( 20, message.ld, true );
    dv.setFloat32( 24, message.lq, true );
    dv.setFloat32( 28, message.fluxLinkage, true );
    dv.setUint32( 32, message.gitHash, true );
    dv.setUint32( 36, message.deviceId1, true );
    dv.setUint32( 40, message.deviceId2, true );
    dv.setUint32( 44, message.deviceId3, true );
    return dv;
};

export const serializeStartParamDetectRequest = ( message: IStartParamDetectRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_PARAM_DETECT );
    dv.setFloat32( 4, message.paramDetectMaxCurrent, true );
    dv.setFloat32( 8, message.paramDetectMaxRpm, true );
    dv.setUint8( 12, message.motorIndex );
    return dv;
};

export const serializeStartParamDetectResponse = ( message: IStartParamDetectResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_PARAM_DETECT );
    dv.setFloat32( 4, message.resistance, true );
    dv.setFloat32( 8, message.ld, true );
    dv.setFloat32( 12, message.lq, true );
    dv.setFloat32( 16, message.fluxLinkage, true );
    return dv;
};

export const serializeWriteInputConfigRequest = ( message: IWriteInputConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_INPUT_CONFIG );
    dv.setUint32( 4, message.inputLimitUpper, true );
    dv.setUint32( 8, message.inputLimitLower, true );
    dv.setUint32( 12, message.inputLimitCenter, true );
    dv.setUint8( 16, message.inputMode );
    dv.setUint8( 17, message.alwaysOn );
    return dv;
};

export const serializeWriteInputConfigResponse = ( message: IWriteInputConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_INPUT_CONFIG );
    dv.setUint32( 4, message.inputLimitUpper, true );
    dv.setUint32( 8, message.inputLimitLower, true );
    dv.setUint32( 12, message.inputLimitCenter, true );
    dv.setUint8( 16, message.inputMode );
    dv.setUint8( 17, message.alwaysOn );
    return dv;
};

export const serializeWritePowerConfigRequest = ( message: IWritePowerConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_POWER_CONFIG );
    dv.setFloat32( 4, message.motorCurrentLimit, true );
    dv.setFloat32( 8, message.batteryCurrentLimit, true );
    dv.setFloat32( 12, message.criticalOvervoltageThreshold, true );
    dv.setFloat32( 16, message.criticalUndervoltageThreshold, true );
    dv.setFloat32( 20, message.overcurrentThresholdDeprecated, true );
    dv.setFloat32( 24, message.overtemperatureThreshold, true );
    dv.setFloat32( 28, message.warningOvervoltageThreshold, true );
    dv.setFloat32( 32, message.warningUndervoltageThreshold, true );
    dv.setFloat32( 36, message.warningMotorCurrentThreshold, true );
    dv.setFloat32( 40, message.criticalMotorCurrentThreshold, true );
    return dv;
};

export const serializeWritePowerConfigResponse = ( message: IWritePowerConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_POWER_CONFIG );
    dv.setFloat32( 4, message.motorCurrentLimit, true );
    dv.setFloat32( 8, message.batteryCurrentLimit, true );
    dv.setFloat32( 12, message.criticalOvervoltageThreshold, true );
    dv.setFloat32( 16, message.criticalUndervoltageThreshold, true );
    dv.setFloat32( 20, message.overcurrentThresholdDeprecated, true );
    dv.setFloat32( 24, message.overtemperatureThreshold, true );
    dv.setFloat32( 28, message.warningOvervoltageThreshold, true );
    dv.setFloat32( 32, message.warningUndervoltageThreshold, true );
    dv.setFloat32( 36, message.warningMotorCurrentThreshold, true );
    dv.setFloat32( 40, message.criticalMotorCurrentThreshold, true );
    return dv;
};

export const serializeReadFaultRequest = ( message: IReadFaultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_FAULT );
    return dv;
};

export const serializeReadFaultResponse = ( message: IReadFaultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_FAULT );
    return dv;
};

export const serializeReadTelemetryRequest = ( message: IReadTelemetryRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_TELEMETRY );
    return dv;
};

export const serializeReadTelemetryResponse = ( message: IReadTelemetryResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_TELEMETRY );
    return dv;
};

export const serializeReadMotorParamRequest = ( message: IReadMotorParamRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_MOTOR_PARAM );
    return dv;
};

export const serializeReadMotorParamResponse = ( message: IReadMotorParamResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_MOTOR_PARAM );
    return dv;
};

export const serializeReadInputConfigRequest = ( message: IReadInputConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_INPUT_CONFIG );
    return dv;
};

export const serializeReadInputConfigResponse = ( message: IReadInputConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_INPUT_CONFIG );
    dv.setUint32( 4, message.inputLimitUpper, true );
    dv.setUint32( 8, message.inputLimitLower, true );
    dv.setUint32( 12, message.inputLimitCenter, true );
    dv.setUint8( 16, message.inputMode );
    dv.setUint8( 17, message.alwaysOn );
    return dv;
};

export const serializeReadPowerConfigRequest = ( message: IReadPowerConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POWER_CONFIG );
    return dv;
};

export const serializeReadPowerConfigResponse = ( message: IReadPowerConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POWER_CONFIG );
    dv.setFloat32( 4, message.motorCurrentLimit, true );
    dv.setFloat32( 8, message.batteryCurrentLimit, true );
    dv.setFloat32( 12, message.criticalOvervoltageThreshold, true );
    dv.setFloat32( 16, message.criticalUndervoltageThreshold, true );
    dv.setFloat32( 20, message.overcurrentThresholdDeprecated, true );
    dv.setFloat32( 24, message.overtemperatureThreshold, true );
    dv.setFloat32( 28, message.warningOvervoltageThreshold, true );
    dv.setFloat32( 32, message.warningUndervoltageThreshold, true );
    dv.setFloat32( 36, message.warningMotorCurrentThreshold, true );
    dv.setFloat32( 40, message.criticalMotorCurrentThreshold, true );
    return dv;
};

export const serializeWriteParametersRequest = ( message: IWriteParametersRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_PARAMETERS );
    dv.setFloat32( 4, message.resistance, true );
    dv.setFloat32( 8, message.ld, true );
    dv.setFloat32( 12, message.lq, true );
    dv.setFloat32( 16, message.fluxLinkage, true );
    return dv;
};

export const serializeWriteParametersResponse = ( message: IWriteParametersResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_PARAMETERS );
    dv.setFloat32( 4, message.resistance, true );
    dv.setFloat32( 8, message.ld, true );
    dv.setFloat32( 12, message.lq, true );
    dv.setFloat32( 16, message.fluxLinkage, true );
    return dv;
};

export const serializeWriteControlConfigRequest = ( message: IWriteControlConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_CONTROL_CONFIG );
    dv.setFloat32( 4, message.motorMaxSpeed, true );
    dv.setFloat32( 8, message.polePairCount, true );
    dv.setFloat32( 12, message.speedControlProportionalGain, true );
    dv.setFloat32( 16, message.speedControlIntegralGain, true );
    dv.setFloat32( 20, message.deprecatedPositionControlProportionalGain, true );
    dv.setUint8( 24, message.controlMode );
    dv.setInt8( 25, message.mtpa );
    dv.setInt8( 26, message.fluxWeakening );
    return dv;
};

export const serializeWriteControlConfigResponse = ( message: IWriteControlConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_CONTROL_CONFIG );
    dv.setFloat32( 4, message.motorMaxSpeed, true );
    dv.setFloat32( 8, message.polePairCount, true );
    dv.setFloat32( 12, message.speedControlProportionalGain, true );
    dv.setFloat32( 16, message.speedControlIntegralGain, true );
    dv.setFloat32( 20, message.deprecatedPositionControlProportionalGain, true );
    dv.setUint8( 24, message.controlMode );
    dv.setInt8( 25, message.mtpa );
    dv.setInt8( 26, message.fluxWeakening );
    return dv;
};

export const serializeWriteSensorModeRequest = ( message: IWriteSensorModeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_SENSOR_MODE );
    dv.setUint8( 4, message.sensorMode );
    dv.setUint32( 5, message.encoderCpr, true );
    return dv;
};

export const serializeWriteSensorModeResponse = ( message: IWriteSensorModeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_SENSOR_MODE );
    dv.setUint8( 4, message.sensorMode );
    dv.setUint32( 5, message.encoderCpr, true );
    return dv;
};

export const serializeReadSensorModeRequest = ( message: IReadSensorModeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_SENSOR_MODE );
    return dv;
};

export const serializeReadSensorModeResponse = ( message: IReadSensorModeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_SENSOR_MODE );
    dv.setUint8( 4, message.sensorMode );
    dv.setUint32( 5, message.encoderCpr, true );
    dv.setFloat32( 9, message.encoderOffset, true );
    dv.setInt8( 13, message.encoderDirection );
    dv.setFloat32( 14, message.hallsensorForwardOffset, true );
    dv.setFloat32( 18, message.hallsensorReverseOffset, true );
    dv.setInt8( 22, message.hallsensorDirection );
    return dv;
};

export const serializeStartEncoderCalRequest = ( message: IStartEncoderCalRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_ENCODER_CAL );
    dv.setUint8( 4, message.motorIndex );
    return dv;
};

export const serializeStartEncoderCalResponse = ( message: IStartEncoderCalResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_ENCODER_CAL );
    return dv;
};

export const serializeGetEncoderCalResultRequest = ( message: IGetEncoderCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_ENCODER_CAL_RESULT );
    return dv;
};

export const serializeGetEncoderCalResultResponse = ( message: IGetEncoderCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_ENCODER_CAL_RESULT );
    dv.setFloat32( 4, message.offset, true );
    dv.setUint8( 8, message.status );
    dv.setInt8( 9, message.direction );
    return dv;
};

export const serializeEncoderCalResultRequest = ( message: IEncoderCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENCODER_CAL_RESULT );
    return dv;
};

export const serializeEncoderCalResultResponse = ( message: IEncoderCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENCODER_CAL_RESULT );
    dv.setFloat32( 4, message.offset, true );
    dv.setUint8( 8, message.status );
    dv.setInt8( 9, message.direction );
    return dv;
};

export const serializeWriteOpenLoopConfigRequest = ( message: IWriteOpenLoopConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_OPEN_LOOP_CONFIG );
    dv.setFloat32( 4, message.accelerationRamp, true );
    return dv;
};

export const serializeWriteOpenLoopConfigResponse = ( message: IWriteOpenLoopConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_OPEN_LOOP_CONFIG );
    dv.setFloat32( 4, message.accelerationRamp, true );
    return dv;
};

export const serializeReadControlModeRequest = ( message: IReadControlModeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_CONTROL_MODE );
    return dv;
};

export const serializeReadControlModeResponse = ( message: IReadControlModeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_CONTROL_MODE );
    dv.setUint8( 4, message.controlMode );
    return dv;
};

export const serializeWriteCanIdRequest = ( message: IWriteCanIdRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_CAN_ID );
    dv.setUint32( 4, message.canId, true );
    return dv;
};

export const serializeWriteCanIdResponse = ( message: IWriteCanIdResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_CAN_ID );
    dv.setUint32( 4, message.canId, true );
    return dv;
};

export const serializeReadCanIdRequest = ( message: IReadCanIdRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_CAN_ID );
    return dv;
};

export const serializeReadCanIdResponse = ( message: IReadCanIdResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_CAN_ID );
    dv.setUint32( 4, message.canId, true );
    return dv;
};

export const serializeWriteEscIdRequest = ( message: IWriteEscIdRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_ESC_ID );
    dv.setUint32( 4, message.escIndex, true );
    return dv;
};

export const serializeWriteEscIdResponse = ( message: IWriteEscIdResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_ESC_ID );
    dv.setUint32( 4, message.escIndex, true );
    return dv;
};

export const serializeReadEscIdRequest = ( message: IReadEscIdRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_ESC_ID );
    return dv;
};

export const serializeReadEscIdResponse = ( message: IReadEscIdResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_ESC_ID );
    dv.setUint32( 4, message.escIndex, true );
    return dv;
};

export const serializeGetBuildInfoRequest = ( message: IGetBuildInfoRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_BUILD_INFO );
    return dv;
};

export const serializeGetBuildInfoResponse = ( message: IGetBuildInfoResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_BUILD_INFO );
    dv.setUint32( 4, message.year, true );
    dv.setUint32( 8, message.month, true );
    dv.setUint32( 12, message.day, true );
    dv.setUint32( 16, message.increment, true );
    dv.setUint8( 20, message.buildType );
    dv.setUint32( 21, message.dirty, true );
    return dv;
};

export const serializeReadMtpaStatusRequest = ( message: IReadMtpaStatusRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_MTPA_STATUS );
    return dv;
};

export const serializeReadMtpaStatusResponse = ( message: IReadMtpaStatusResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_MTPA_STATUS );
    dv.setInt8( 4, message.mtpa );
    return dv;
};

export const serializeReadFluxWeakeningStatusRequest = ( message: IReadFluxWeakeningStatusRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_FLUX_WEAKENING_STATUS );
    return dv;
};

export const serializeReadFluxWeakeningStatusResponse = ( message: IReadFluxWeakeningStatusResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_FLUX_WEAKENING_STATUS );
    dv.setInt8( 4, message.fluxWeakening );
    return dv;
};

export const serializeWritePositionControlSettingsRequest = ( message: IWritePositionControlSettingsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_POSITION_CONTROL_SETTINGS );
    dv.setFloat32( 4, message.positionControlProportionalGain, true );
    dv.setFloat32( 8, message.positionControlIntegralGain, true );
    dv.setFloat32( 12, message.positionControlDerivGain, true );
    dv.setFloat32( 16, message.positionControlMaxSpeed, true );
    dv.setFloat32( 20, message.positionControlMaxAccel, true );
    dv.setFloat32( 24, message.positionControlDeadband, true );
    dv.setInt8( 28, message.positionControlType );
    dv.setInt8( 29, message.positionUnits );
    dv.setInt8( 30, message.positionResolution );
    dv.setFloat32( 31, message.travelDistance, true );
    dv.setUint8( 35, message.softStopRangePercent );
    return dv;
};

export const serializeWritePositionControlSettingsResponse = ( message: IWritePositionControlSettingsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_POSITION_CONTROL_SETTINGS );
    dv.setFloat32( 4, message.positionControlProportionalGain, true );
    dv.setFloat32( 8, message.positionControlIntegralGain, true );
    dv.setFloat32( 12, message.positionControlDerivGain, true );
    dv.setFloat32( 16, message.positionControlMaxSpeed, true );
    dv.setFloat32( 20, message.positionControlMaxAccel, true );
    dv.setFloat32( 24, message.positionControlDeadband, true );
    dv.setInt8( 28, message.positionControlType );
    dv.setInt8( 29, message.positionUnits );
    dv.setInt8( 30, message.positionResolution );
    dv.setFloat32( 31, message.travelDistance, true );
    dv.setUint8( 35, message.softStopRangePercent );
    return dv;
};

export const serializeReadPositionControlSettingsRequest = ( message: IReadPositionControlSettingsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POSITION_CONTROL_SETTINGS );
    return dv;
};

export const serializeReadPositionControlSettingsResponse = ( message: IReadPositionControlSettingsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POSITION_CONTROL_SETTINGS );
    dv.setFloat32( 4, message.positionControlProportionalGain, true );
    dv.setFloat32( 8, message.positionControlIntegralGain, true );
    dv.setFloat32( 12, message.positionControlDerivGain, true );
    dv.setFloat32( 16, message.positionControlMaxSpeed, true );
    dv.setFloat32( 20, message.positionControlMaxAccel, true );
    dv.setFloat32( 24, message.positionControlDeadband, true );
    dv.setInt8( 28, message.positionControlType );
    dv.setInt8( 29, message.positionUnits );
    dv.setInt8( 30, message.positionResolution );
    dv.setFloat32( 31, message.travelDistance, true );
    dv.setUint8( 35, message.softStopRangePercent );
    return dv;
};

export const serializeSetPositionSensorLimitsRequest = ( message: ISetPositionSensorLimitsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_POSITION_SENSOR_LIMITS );
    dv.setUint8( 4, message.setCurrentPosToMin );
    dv.setUint8( 5, message.setCurrentPosToMax );
    dv.setUint8( 6, message.motorIndex );
    return dv;
};

export const serializeSetPositionSensorLimitsResponse = ( message: ISetPositionSensorLimitsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_POSITION_SENSOR_LIMITS );
    dv.setFloat32( 4, message.minPosition, true );
    dv.setFloat32( 8, message.maxPosition, true );
    return dv;
};

export const serializeReadPositionSensorLimitsRequest = ( message: IReadPositionSensorLimitsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POSITION_SENSOR_LIMITS );
    return dv;
};

export const serializeReadPositionSensorLimitsResponse = ( message: IReadPositionSensorLimitsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POSITION_SENSOR_LIMITS );
    dv.setFloat32( 4, message.minValue, true );
    dv.setFloat32( 8, message.maxValue, true );
    return dv;
};

export const serializeStartHallSensorCalRequest = ( message: IStartHallSensorCalRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_HALL_SENSOR_CAL );
    dv.setUint8( 4, message.motorIndex );
    return dv;
};

export const serializeStartHallSensorCalResponse = ( message: IStartHallSensorCalResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_HALL_SENSOR_CAL );
    return dv;
};

export const serializeGetHallSensorCalResultRequest = ( message: IGetHallSensorCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_HALL_SENSOR_CAL_RESULT );
    return dv;
};

export const serializeGetHallSensorCalResultResponse = ( message: IGetHallSensorCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_HALL_SENSOR_CAL_RESULT );
    dv.setFloat32( 4, message.forwardOffset, true );
    dv.setFloat32( 8, message.reverseOffset, true );
    dv.setUint8( 12, message.status );
    dv.setInt8( 13, message.direction );
    return dv;
};

export const serializeHallSensorCalResultRequest = ( message: IHallSensorCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HALL_SENSOR_CAL_RESULT );
    return dv;
};

export const serializeHallSensorCalResultResponse = ( message: IHallSensorCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HALL_SENSOR_CAL_RESULT );
    dv.setFloat32( 4, message.forwardOffset, true );
    dv.setFloat32( 8, message.reverseOffset, true );
    dv.setUint8( 12, message.status );
    dv.setInt8( 13, message.direction );
    return dv;
};

export const serializeClearAllFaultsRequest = ( message: IClearAllFaultsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CLEAR_ALL_FAULTS );
    return dv;
};

export const serializeClearAllFaultsResponse = ( message: IClearAllFaultsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CLEAR_ALL_FAULTS );
    return dv;
};

export const serializeCertExchange1Request = ( message: ICertExchange1Request ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CERT_EXCHANGE_1 );
    for ( let i = 0; i < 50; i++ ) dv.setUint8( 4 + i, message.sLabCertFirstHalf[ i ] );
    return dv;
};

export const serializeCertExchange1Response = ( message: ICertExchange1Response ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CERT_EXCHANGE_1 );
    for ( let i = 0; i < 50; i++ ) dv.setUint8( 4 + i, message.mcuCertFirstHalf[ i ] );
    return dv;
};

export const serializeCertExchange2Request = ( message: ICertExchange2Request ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CERT_EXCHANGE_2 );
    for ( let i = 0; i < 50; i++ ) dv.setUint8( 4 + i, message.sLabCertLastHalf[ i ] );
    return dv;
};

export const serializeCertExchange2Response = ( message: ICertExchange2Response ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CERT_EXCHANGE_2 );
    dv.setInt8( 4, message.result );
    for ( let i = 0; i < 50; i++ ) dv.setUint8( 5 + i, message.mcuCertLastHalf[ i ] );
    return dv;
};

export const serializeEncChallenge1Request = ( message: IEncChallenge1Request ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENC_CHALLENGE_1 );
    for ( let i = 0; i < 16; i++ ) dv.setUint8( 4 + i, message.challengeA[ i ] );
    return dv;
};

export const serializeEncChallenge1Response = ( message: IEncChallenge1Response ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENC_CHALLENGE_1 );
    for ( let i = 0; i < 16; i++ ) dv.setUint8( 4 + i, message.encChallengeA[ i ] );
    for ( let i = 0; i < 16; i++ ) dv.setUint8( 20 + i, message.challengeB[ i ] );
    return dv;
};

export const serializeEncChallenge2Request = ( message: IEncChallenge2Request ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENC_CHALLENGE_2 );
    for ( let i = 0; i < 16; i++ ) dv.setUint8( 4 + i, message.encChallengeB[ i ] );
    return dv;
};

export const serializeEncChallenge2Response = ( message: IEncChallenge2Response ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENC_CHALLENGE_2 );
    dv.setInt8( 4, message.result );
    return dv;
};

export const serializeKeepAliveRequest = ( message: IKeepAliveRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.KEEP_ALIVE );
    return dv;
};

export const serializeKeepAliveResponse = ( message: IKeepAliveResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.KEEP_ALIVE );
    dv.setInt8( 4, message.authStatus );
    return dv;
};

export const serializeKeyConfigRequest = ( message: IKeyConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.KEY_CONFIG );
    for ( let i = 0; i < 60; i++ ) dv.setUint8( 4 + i, message.keyBytestream[ i ] );
    return dv;
};

export const serializeKeyConfigResponse = ( message: IKeyConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.KEY_CONFIG );
    for ( let i = 0; i < 60; i++ ) dv.setUint8( 4 + i, message.keyBytestreamRsp[ i ] );
    return dv;
};

export const serializeStartHomingCalRequest = ( message: IStartHomingCalRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_HOMING_CAL );
    return dv;
};

export const serializeStartHomingCalResponse = ( message: IStartHomingCalResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_HOMING_CAL );
    return dv;
};

export const serializeHomingCalResultRequest = ( message: IHomingCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HOMING_CAL_RESULT );
    return dv;
};

export const serializeHomingCalResultResponse = ( message: IHomingCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HOMING_CAL_RESULT );
    dv.setFloat32( 4, message.zeroOffset, true );
    dv.setUint8( 8, message.status );
    return dv;
};

export const serializeStartSysidRequest = ( message: IStartSysidRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_SYSID );
    dv.setUint8( 4, message.motorIndex );
    return dv;
};

export const serializeStartSysidResponse = ( message: IStartSysidResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_SYSID );
    return dv;
};

export const serializeStopSysidRequest = ( message: IStopSysidRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.STOP_SYSID );
    return dv;
};

export const serializeStopSysidResponse = ( message: IStopSysidResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.STOP_SYSID );
    return dv;
};

export const serializeZeroDareSensorRequest = ( message: IZeroDareSensorRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ZERO_DARE_SENSOR );
    return dv;
};

export const serializeZeroDareSensorResponse = ( message: IZeroDareSensorResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ZERO_DARE_SENSOR );
    dv.setUint16( 4, message.encoder0ZeroPos, true );
    dv.setUint16( 6, message.encoder1ZeroPos, true );
    return dv;
};

export const serializeReadTotalActuatorsRequest = ( message: IReadTotalActuatorsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_TOTAL_ACTUATORS );
    return dv;
};

export const serializeReadTotalActuatorsResponse = ( message: IReadTotalActuatorsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_TOTAL_ACTUATORS );
    dv.setUint8( 4, message.detectedNodes );
    dv.setUint8( 5, message.expectedNodes );
    dv.setUint32( 6, message.operationalNodesBitmap, true );
    return dv;
};

export const serializeActuatorInfoRequest = ( message: IActuatorInfoRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ACTUATOR_INFO );
    return dv;
};

export const serializeActuatorInfoResponse = ( message: IActuatorInfoResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ACTUATOR_INFO );
    dv.setUint8( 4, message.nodeId );
    for ( let i = 0; i < 27; i++ ) dv.setUint8( 5 + i, message.dispositionStr[ i ] );
    return dv;
};

export const serializeSetControlModeRequest = ( message: ISetControlModeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_CONTROL_MODE );
    dv.setUint8( 4, message.controlMode );
    return dv;
};

export const serializeSetControlModeResponse = ( message: ISetControlModeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_CONTROL_MODE );
    dv.setUint8( 4, message.controlMode );
    return dv;
};

export const serializeEnableBulkTelemetryRequest = ( message: IEnableBulkTelemetryRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENABLE_BULK_TELEMETRY );
    dv.setUint8( 4, message.enable );
    return dv;
};

export const serializeEnableBulkTelemetryResponse = ( message: IEnableBulkTelemetryResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENABLE_BULK_TELEMETRY );
    dv.setUint8( 4, message.enabled );
    return dv;
};

export const serializeSetTelemRateRequest = ( message: ISetTelemRateRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_TELEM_RATE );
    dv.setUint32( 4, message.requestedHz, true );
    return dv;
};

export const serializeSetTelemRateResponse = ( message: ISetTelemRateResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_TELEM_RATE );
    dv.setUint32( 4, message.achievedHz, true );
    return dv;
};

export const serializeGetCapabilitiesRequest = ( message: IGetCapabilitiesRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_CAPABILITIES );
    return dv;
};

export const serializeGetCapabilitiesResponse = ( message: IGetCapabilitiesResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_CAPABILITIES );
    dv.setUint8( 4, message.count );
    for ( let i = 0; i < 59; i++ ) dv.setUint8( 5 + i, message.entries[ i ] );
    return dv;
};

export const serializeAutotuneControlRequest = ( message: IAutotuneControlRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.AUTOTUNE_CONTROL );
    dv.setUint8( 4, message.motorIndex );
    dv.setUint8( 5, message.command );
    dv.setUint8( 6, message.targetPhase );
    return dv;
};

export const serializeAutotuneControlResponse = ( message: IAutotuneControlResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.AUTOTUNE_CONTROL );
    dv.setUint8( 4, message.motorIndex );
    dv.setUint8( 5, message.status );
    dv.setUint8( 6, message.currentPhase );
    dv.setUint8( 7, message.errorCode );
    dv.setFloat32( 8, message.xHalfSafeRad, true );
    dv.setFloat32( 12, message.wFeasibleRadps, true );
    dv.setFloat32( 16, message.alphaBrakeRadps2, true );
    dv.setFloat32( 20, message.jAssumedKgm2, true );
    return dv;
};

export const serializeGetAutotuneStatusRequest = ( message: IGetAutotuneStatusRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_AUTOTUNE_STATUS );
    dv.setUint8( 4, message.motorIndex );
    return dv;
};

export const serializeGetAutotuneStatusResponse = ( message: IGetAutotuneStatusResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_AUTOTUNE_STATUS );
    dv.setUint8( 4, message.motorIndex );
    dv.setUint8( 5, message.status );
    dv.setUint8( 6, message.phase );
    dv.setUint8( 7, message.phaseProgress );
    dv.setUint8( 8, message.errorCode );
    dv.setFloat32( 9, message.currentSpeedRadps, true );
    dv.setFloat32( 13, message.currentTorqueNm, true );
    dv.setFloat32( 17, message.currentPositionRad, true );
    dv.setFloat32( 21, message.commandedSpeedRadps, true );
    dv.setFloat32( 25, message.commandedTorqueNm, true );
    dv.setFloat32( 29, message.identifiedJKgm2, true );
    dv.setFloat32( 33, message.identifiedBNmsrad, true );
    dv.setFloat32( 37, message.speedKp, true );
    dv.setFloat32( 41, message.speedKi, true );
    dv.setFloat32( 45, message.positionKp, true );
    dv.setUint8( 49, message.lastExitNextState );
    dv.setUint8( 50, message.lastExitReason );
    dv.setUint8( 51, message.lastExitPhase );
    dv.setUint8( 52, message.lastExitError );
    dv.setUint32( 53, message.lastExitTimeMs, true );
    dv.setUint8( 57, message.safetyTripFlags );
    dv.setUint8( 58, message.idJFailReason );
    dv.setFloat32( 59, message.jLatestTrialKgm2, true );
    dv.setUint8( 63, message.idBFailReason );
    return dv;
};

export const serializeSetAutotuneConfigRequest = ( message: ISetAutotuneConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_AUTOTUNE_CONFIG );
    dv.setUint8( 4, message.motorIndex );
    dv.setFloat32( 5, message.maxCurrentA, true );
    dv.setFloat32( 9, message.maxSpeedRadps, true );
    dv.setFloat32( 13, message.maxAccelRadps2, true );
    dv.setFloat32( 17, message.positionWindowRad, true );
    dv.setFloat32( 21, message.speedBandwidthHz, true );
    dv.setFloat32( 25, message.disturbanceRejectDb, true );
    dv.setFloat32( 29, message.phaseMarginDeg, true );
    dv.setFloat32( 33, message.positionBandwidthHz, true );
    dv.setFloat32( 37, message.gearRatio, true );
    dv.setFloat32( 41, message.ktNma, true );
    dv.setFloat32( 45, message.polePairs, true );
    dv.setFloat32( 49, message.zeroPlacementDivisor, true );
    dv.setUint8( 53, message.bootstrapRateLevel );
    dv.setFloat32( 54, message.bootstrapMaxSpeedRadps, true );
    dv.setUint8( 58, message.skipBootstrap );
    return dv;
};

export const serializeSetAutotuneConfigResponse = ( message: ISetAutotuneConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_AUTOTUNE_CONFIG );
    dv.setUint8( 4, message.motorIndex );
    dv.setUint8( 5, message.status );
    return dv;
};

export const serializeGetAutotuneParamsRequest = ( message: IGetAutotuneParamsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_AUTOTUNE_PARAMS );
    dv.setUint8( 4, message.motorIndex );
    return dv;
};

export const serializeGetAutotuneParamsResponse = ( message: IGetAutotuneParamsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_AUTOTUNE_PARAMS );
    dv.setUint8( 4, message.motorIndex );
    dv.setFloat32( 5, message.inertiaKgm2, true );
    dv.setFloat32( 9, message.viscousFrictionNms, true );
    dv.setFloat32( 13, message.coulombFrictionNm, true );
    dv.setFloat32( 17, message.staticFrictionNm, true );
    dv.setFloat32( 21, message.speedKp, true );
    dv.setFloat32( 25, message.speedKi, true );
    dv.setFloat32( 29, message.positionKp, true );
    dv.setFloat32( 33, message.positionKi, true );
    dv.setFloat32( 37, message.speedBandwidthHz, true );
    dv.setFloat32( 41, message.speedPhaseMarginDeg, true );
    dv.setFloat32( 45, message.speedSettlingTimeMs, true );
    dv.setFloat32( 49, message.speedOvershootPct, true );
    dv.setFloat32( 53, message.positionBandwidthHz, true );
    dv.setFloat32( 57, message.positionSettlingTimeMs, true );
    return dv;
};

export const serializeGetSensorCalStatusRequest = ( message: IGetSensorCalStatusRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_SENSOR_CAL_STATUS );
    dv.setUint8( 4, message.motorIndex );
    return dv;
};

export const serializeGetSensorCalStatusResponse = ( message: IGetSensorCalStatusResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_SENSOR_CAL_STATUS );
    dv.setUint8( 4, message.motorIndex );
    dv.setUint8( 5, message.calStatus );
    dv.setUint32( 6, message.sampleCount, true );
    dv.setFloat32( 10, message.meanAngleErrorDeg, true );
    dv.setFloat32( 14, message.stddevAngleErrorDeg, true );
    dv.setFloat32( 18, message.sensorNoiseMeanDeg, true );
    dv.setFloat32( 22, message.sensorNoiseStddevDeg, true );
    dv.setFloat32( 26, message.dAxisOffsetRad, true );
    dv.setFloat32( 30, message.lastAngleErrorDeg, true );
    return dv;
};

export const serializeSetSeatMotionRequest = ( message: ISetSeatMotionRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_SEAT_MOTION );
    dv.setUint8( 4, message.seat );
    dv.setUint8( 5, message.action );
    return dv;
};

export const serializeSetSeatMotionResponse = ( message: ISetSeatMotionResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_SEAT_MOTION );
    dv.setUint8( 4, message.seat );
    dv.setUint8( 5, message.action );
    dv.setUint8( 6, message.accepted );
    dv.setUint8( 7, message.state );
    return dv;
};

export const serializeDeviceLogsRequest = ( message: IDeviceLogsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.DEVICE_LOGS );
    dv.setUint16( 4, message.recordOffset, true );
    dv.setUint16( 6, message.recordCount, true );
    return dv;
};

export const serializeDeviceLogsResponse = ( message: IDeviceLogsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.DEVICE_LOGS );
    dv.setUint32( 4, message.recordNumber, true );
    for ( let i = 0; i < 56; i++ ) dv.setUint8( 8 + i, message.msgSegment[ i ] );
    return dv;
};

export const serializeSetUsbThrottleControlRequest = ( message: ISetUsbThrottleControlRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_USB_THROTTLE_CONTROL );
    dv.setUint32( 4, message.value, true );
    dv.setUint8( 8, message.motorIndex );
    return dv;
};

export const serializeSetUsbThrottleControlResponse = ( message: ISetUsbThrottleControlResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_USB_THROTTLE_CONTROL );
    dv.setUint32( 4, message.value, true );
    dv.setUint8( 8, message.motorIndex );
    return dv;
};

export const serializeFaultDataMessage = ( message: IFaultDataMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.FAULT_DATA );
    dv.setUint32( 4, message.code, true );
    return dv;
};

export const serializeRealtimeDataMessage = ( message: IRealtimeDataMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.REALTIME_DATA );
    dv.setFloat32( 4, message.motorSpeed, true );
    dv.setFloat32( 8, message.motorCurrent, true );
    dv.setFloat32( 12, message.batteryVoltage, true );
    dv.setFloat32( 16, message.batteryCurrent, true );
    dv.setFloat32( 20, message.servoPulse, true );
    dv.setFloat32( 24, message.inverterTemp, true );
    dv.setUint8( 28, message.controllerState );
    dv.setUint8( 29, message.faultCodeDeprecated );
    dv.setUint32( 30, message.uptimeMs, true );
    dv.setFloat32( 34, message.motorPosition, true );
    dv.setFloat32( 38, message.positionSensorReading, true );
    dv.setUint32( 42, message.faultsBitmapLower32, true );
    dv.setUint16( 46, message.faultsBitmapUpper16, true );
    dv.setFloat32( 48, message.externalThermTemp, true );
    dv.setFloat32( 52, message.rawPositionSensor, true );
    dv.setFloat32( 56, message.sysidFrequency, true );
    dv.setFloat32( 60, message.sysidMagnitude, true );
    return dv;
};

export const serializeVariableTelemetryMessage = ( message: IVariableTelemetryMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.VARIABLE_TELEMETRY );
    dv.setUint8( 4, message.telemId );
    for ( let i = 0; i < 59; i++ ) dv.setUint8( 5 + i, message.telemBytestream[ i ] );
    return dv;
};

export const serializeMultiMotorTelemetryMessage = ( message: IMultiMotorTelemetryMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.MULTI_MOTOR_TELEMETRY );
    dv.setUint8( 4, message.actuatorNodeId );
    dv.setUint32( 5, message.faultsBitmapLower32, true );
    dv.setUint16( 9, message.faultsBitmapUpper16, true );
    dv.setInt32( 11, message.positionActualPctOfRange, true );
    dv.setInt32( 15, message.velocityActualValue, true );
    dv.setInt16( 19, message.torqueActualValue, true );
    dv.setInt16( 21, message.electricalCurrentActualValue, true );
    dv.setUint32( 23, message.targetPositionPctOfRange, true );
    dv.setUint16( 27, message.statusWord, true );
    dv.setFloat32( 29, message.mosfetTemperature, true );
    dv.setFloat32( 33, message.batteryCurrent, true );
    dv.setFloat32( 37, message.motorCurrent, true );
    dv.setFloat32( 41, message.motorTemperature, true );
    dv.setFloat32( 45, message.positionActualValue, true );
    dv.setFloat32( 49, message.positionSensorRawValue, true );
    dv.setFloat32( 53, message.positionUserUnits, true );
    return dv;
};

export const serializeFirmwareUpdateRequest = ( message: IFirmwareUpdateRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.FIRMWARE_UPDATE );
    return dv;
};

export const serializeFirmwareUpdateResponse = ( message: IFirmwareUpdateResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.FIRMWARE_UPDATE );
    return dv;
};

export const serializeUserDefinedMessage = ( message: IUserDefinedMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.USER_DEFINED );
    return dv;
};
export const deserializeInvalidRequest = ( dv: DataView ): IInvalidRequest => {
    return {
    };
};

export const deserializeInvalidResponse = ( dv: DataView ): IInvalidResponse => {
    return {
    };
};

export const deserializeHandshakeRequest = ( dv: DataView ): IHandshakeRequest => {
    return {
    };
};

export const deserializeHandshakeResponse = ( dv: DataView ): IHandshakeResponse => {
    return {
        versionMajor: dv.getUint32( 4, true ),
        versionMinor: dv.getUint32( 8, true ),
        versionBuild: dv.getUint32( 12, true ),
        resistance: dv.getFloat32( 16, true ),
        ld: dv.getFloat32( 20, true ),
        lq: dv.getFloat32( 24, true ),
        fluxLinkage: dv.getFloat32( 28, true ),
        gitHash: dv.getUint32( 32, true ),
        deviceId1: dv.getUint32( 36, true ),
        deviceId2: dv.getUint32( 40, true ),
        deviceId3: dv.getUint32( 44, true ),
    };
};

export const deserializeStartParamDetectRequest = ( dv: DataView ): IStartParamDetectRequest => {
    return {
        paramDetectMaxCurrent: dv.getFloat32( 4, true ),
        paramDetectMaxRpm: dv.getFloat32( 8, true ),
        motorIndex: dv.getUint8( 12 ),
    };
};

export const deserializeStartParamDetectResponse = ( dv: DataView ): IStartParamDetectResponse => {
    return {
        resistance: dv.getFloat32( 4, true ),
        ld: dv.getFloat32( 8, true ),
        lq: dv.getFloat32( 12, true ),
        fluxLinkage: dv.getFloat32( 16, true ),
    };
};

export const deserializeWriteInputConfigRequest = ( dv: DataView ): IWriteInputConfigRequest => {
    return {
        inputLimitUpper: dv.getUint32( 4, true ),
        inputLimitLower: dv.getUint32( 8, true ),
        inputLimitCenter: dv.getUint32( 12, true ),
        inputMode: dv.getUint8( 16 ),
        alwaysOn: dv.getUint8( 17 ),
    };
};

export const deserializeWriteInputConfigResponse = ( dv: DataView ): IWriteInputConfigResponse => {
    return {
        inputLimitUpper: dv.getUint32( 4, true ),
        inputLimitLower: dv.getUint32( 8, true ),
        inputLimitCenter: dv.getUint32( 12, true ),
        inputMode: dv.getUint8( 16 ),
        alwaysOn: dv.getUint8( 17 ),
    };
};

export const deserializeWritePowerConfigRequest = ( dv: DataView ): IWritePowerConfigRequest => {
    return {
        motorCurrentLimit: dv.getFloat32( 4, true ),
        batteryCurrentLimit: dv.getFloat32( 8, true ),
        criticalOvervoltageThreshold: dv.getFloat32( 12, true ),
        criticalUndervoltageThreshold: dv.getFloat32( 16, true ),
        overcurrentThresholdDeprecated: dv.getFloat32( 20, true ),
        overtemperatureThreshold: dv.getFloat32( 24, true ),
        warningOvervoltageThreshold: dv.getFloat32( 28, true ),
        warningUndervoltageThreshold: dv.getFloat32( 32, true ),
        warningMotorCurrentThreshold: dv.getFloat32( 36, true ),
        criticalMotorCurrentThreshold: dv.getFloat32( 40, true ),
    };
};

export const deserializeWritePowerConfigResponse = ( dv: DataView ): IWritePowerConfigResponse => {
    return {
        motorCurrentLimit: dv.getFloat32( 4, true ),
        batteryCurrentLimit: dv.getFloat32( 8, true ),
        criticalOvervoltageThreshold: dv.getFloat32( 12, true ),
        criticalUndervoltageThreshold: dv.getFloat32( 16, true ),
        overcurrentThresholdDeprecated: dv.getFloat32( 20, true ),
        overtemperatureThreshold: dv.getFloat32( 24, true ),
        warningOvervoltageThreshold: dv.getFloat32( 28, true ),
        warningUndervoltageThreshold: dv.getFloat32( 32, true ),
        warningMotorCurrentThreshold: dv.getFloat32( 36, true ),
        criticalMotorCurrentThreshold: dv.getFloat32( 40, true ),
    };
};

export const deserializeReadFaultRequest = ( dv: DataView ): IReadFaultRequest => {
    return {
    };
};

export const deserializeReadFaultResponse = ( dv: DataView ): IReadFaultResponse => {
    return {
    };
};

export const deserializeReadTelemetryRequest = ( dv: DataView ): IReadTelemetryRequest => {
    return {
    };
};

export const deserializeReadTelemetryResponse = ( dv: DataView ): IReadTelemetryResponse => {
    return {
    };
};

export const deserializeReadMotorParamRequest = ( dv: DataView ): IReadMotorParamRequest => {
    return {
    };
};

export const deserializeReadMotorParamResponse = ( dv: DataView ): IReadMotorParamResponse => {
    return {
    };
};

export const deserializeReadInputConfigRequest = ( dv: DataView ): IReadInputConfigRequest => {
    return {
    };
};

export const deserializeReadInputConfigResponse = ( dv: DataView ): IReadInputConfigResponse => {
    return {
        inputLimitUpper: dv.getUint32( 4, true ),
        inputLimitLower: dv.getUint32( 8, true ),
        inputLimitCenter: dv.getUint32( 12, true ),
        inputMode: dv.getUint8( 16 ),
        alwaysOn: dv.getUint8( 17 ),
    };
};

export const deserializeReadPowerConfigRequest = ( dv: DataView ): IReadPowerConfigRequest => {
    return {
    };
};

export const deserializeReadPowerConfigResponse = ( dv: DataView ): IReadPowerConfigResponse => {
    return {
        motorCurrentLimit: dv.getFloat32( 4, true ),
        batteryCurrentLimit: dv.getFloat32( 8, true ),
        criticalOvervoltageThreshold: dv.getFloat32( 12, true ),
        criticalUndervoltageThreshold: dv.getFloat32( 16, true ),
        overcurrentThresholdDeprecated: dv.getFloat32( 20, true ),
        overtemperatureThreshold: dv.getFloat32( 24, true ),
        warningOvervoltageThreshold: dv.getFloat32( 28, true ),
        warningUndervoltageThreshold: dv.getFloat32( 32, true ),
        warningMotorCurrentThreshold: dv.getFloat32( 36, true ),
        criticalMotorCurrentThreshold: dv.getFloat32( 40, true ),
    };
};

export const deserializeWriteParametersRequest = ( dv: DataView ): IWriteParametersRequest => {
    return {
        resistance: dv.getFloat32( 4, true ),
        ld: dv.getFloat32( 8, true ),
        lq: dv.getFloat32( 12, true ),
        fluxLinkage: dv.getFloat32( 16, true ),
    };
};

export const deserializeWriteParametersResponse = ( dv: DataView ): IWriteParametersResponse => {
    return {
        resistance: dv.getFloat32( 4, true ),
        ld: dv.getFloat32( 8, true ),
        lq: dv.getFloat32( 12, true ),
        fluxLinkage: dv.getFloat32( 16, true ),
    };
};

export const deserializeWriteControlConfigRequest = ( dv: DataView ): IWriteControlConfigRequest => {
    return {
        motorMaxSpeed: dv.getFloat32( 4, true ),
        polePairCount: dv.getFloat32( 8, true ),
        speedControlProportionalGain: dv.getFloat32( 12, true ),
        speedControlIntegralGain: dv.getFloat32( 16, true ),
        deprecatedPositionControlProportionalGain: dv.getFloat32( 20, true ),
        controlMode: dv.getUint8( 24 ),
        mtpa: dv.getInt8( 25 ),
        fluxWeakening: dv.getInt8( 26 ),
    };
};

export const deserializeWriteControlConfigResponse = ( dv: DataView ): IWriteControlConfigResponse => {
    return {
        motorMaxSpeed: dv.getFloat32( 4, true ),
        polePairCount: dv.getFloat32( 8, true ),
        speedControlProportionalGain: dv.getFloat32( 12, true ),
        speedControlIntegralGain: dv.getFloat32( 16, true ),
        deprecatedPositionControlProportionalGain: dv.getFloat32( 20, true ),
        controlMode: dv.getUint8( 24 ),
        mtpa: dv.getInt8( 25 ),
        fluxWeakening: dv.getInt8( 26 ),
    };
};

export const deserializeWriteSensorModeRequest = ( dv: DataView ): IWriteSensorModeRequest => {
    return {
        sensorMode: dv.getUint8( 4 ),
        encoderCpr: dv.getUint32( 5, true ),
    };
};

export const deserializeWriteSensorModeResponse = ( dv: DataView ): IWriteSensorModeResponse => {
    return {
        sensorMode: dv.getUint8( 4 ),
        encoderCpr: dv.getUint32( 5, true ),
    };
};

export const deserializeReadSensorModeRequest = ( dv: DataView ): IReadSensorModeRequest => {
    return {
    };
};

export const deserializeReadSensorModeResponse = ( dv: DataView ): IReadSensorModeResponse => {
    return {
        sensorMode: dv.getUint8( 4 ),
        encoderCpr: dv.getUint32( 5, true ),
        encoderOffset: dv.getFloat32( 9, true ),
        encoderDirection: dv.getInt8( 13 ),
        hallsensorForwardOffset: dv.getFloat32( 14, true ),
        hallsensorReverseOffset: dv.getFloat32( 18, true ),
        hallsensorDirection: dv.getInt8( 22 ),
    };
};

export const deserializeStartEncoderCalRequest = ( dv: DataView ): IStartEncoderCalRequest => {
    return {
        motorIndex: dv.getUint8( 4 ),
    };
};

export const deserializeStartEncoderCalResponse = ( dv: DataView ): IStartEncoderCalResponse => {
    return {
    };
};

export const deserializeGetEncoderCalResultRequest = ( dv: DataView ): IGetEncoderCalResultRequest => {
    return {
    };
};

export const deserializeGetEncoderCalResultResponse = ( dv: DataView ): IGetEncoderCalResultResponse => {
    return {
        offset: dv.getFloat32( 4, true ),
        status: dv.getUint8( 8 ),
        direction: dv.getInt8( 9 ),
    };
};

export const deserializeEncoderCalResultRequest = ( dv: DataView ): IEncoderCalResultRequest => {
    return {
    };
};

export const deserializeEncoderCalResultResponse = ( dv: DataView ): IEncoderCalResultResponse => {
    return {
        offset: dv.getFloat32( 4, true ),
        status: dv.getUint8( 8 ),
        direction: dv.getInt8( 9 ),
    };
};

export const deserializeWriteOpenLoopConfigRequest = ( dv: DataView ): IWriteOpenLoopConfigRequest => {
    return {
        accelerationRamp: dv.getFloat32( 4, true ),
    };
};

export const deserializeWriteOpenLoopConfigResponse = ( dv: DataView ): IWriteOpenLoopConfigResponse => {
    return {
        accelerationRamp: dv.getFloat32( 4, true ),
    };
};

export const deserializeReadControlModeRequest = ( dv: DataView ): IReadControlModeRequest => {
    return {
    };
};

export const deserializeReadControlModeResponse = ( dv: DataView ): IReadControlModeResponse => {
    return {
        controlMode: dv.getUint8( 4 ),
    };
};

export const deserializeWriteCanIdRequest = ( dv: DataView ): IWriteCanIdRequest => {
    return {
        canId: dv.getUint32( 4, true ),
    };
};

export const deserializeWriteCanIdResponse = ( dv: DataView ): IWriteCanIdResponse => {
    return {
        canId: dv.getUint32( 4, true ),
    };
};

export const deserializeReadCanIdRequest = ( dv: DataView ): IReadCanIdRequest => {
    return {
    };
};

export const deserializeReadCanIdResponse = ( dv: DataView ): IReadCanIdResponse => {
    return {
        canId: dv.getUint32( 4, true ),
    };
};

export const deserializeWriteEscIdRequest = ( dv: DataView ): IWriteEscIdRequest => {
    return {
        escIndex: dv.getUint32( 4, true ),
    };
};

export const deserializeWriteEscIdResponse = ( dv: DataView ): IWriteEscIdResponse => {
    return {
        escIndex: dv.getUint32( 4, true ),
    };
};

export const deserializeReadEscIdRequest = ( dv: DataView ): IReadEscIdRequest => {
    return {
    };
};

export const deserializeReadEscIdResponse = ( dv: DataView ): IReadEscIdResponse => {
    return {
        escIndex: dv.getUint32( 4, true ),
    };
};

export const deserializeGetBuildInfoRequest = ( dv: DataView ): IGetBuildInfoRequest => {
    return {
    };
};

export const deserializeGetBuildInfoResponse = ( dv: DataView ): IGetBuildInfoResponse => {
    return {
        year: dv.getUint32( 4, true ),
        month: dv.getUint32( 8, true ),
        day: dv.getUint32( 12, true ),
        increment: dv.getUint32( 16, true ),
        buildType: dv.getUint8( 20 ),
        dirty: dv.getUint32( 21, true ),
    };
};

export const deserializeReadMtpaStatusRequest = ( dv: DataView ): IReadMtpaStatusRequest => {
    return {
    };
};

export const deserializeReadMtpaStatusResponse = ( dv: DataView ): IReadMtpaStatusResponse => {
    return {
        mtpa: dv.getInt8( 4 ),
    };
};

export const deserializeReadFluxWeakeningStatusRequest = ( dv: DataView ): IReadFluxWeakeningStatusRequest => {
    return {
    };
};

export const deserializeReadFluxWeakeningStatusResponse = ( dv: DataView ): IReadFluxWeakeningStatusResponse => {
    return {
        fluxWeakening: dv.getInt8( 4 ),
    };
};

export const deserializeWritePositionControlSettingsRequest = ( dv: DataView ): IWritePositionControlSettingsRequest => {
    return {
        positionControlProportionalGain: dv.getFloat32( 4, true ),
        positionControlIntegralGain: dv.getFloat32( 8, true ),
        positionControlDerivGain: dv.getFloat32( 12, true ),
        positionControlMaxSpeed: dv.getFloat32( 16, true ),
        positionControlMaxAccel: dv.getFloat32( 20, true ),
        positionControlDeadband: dv.getFloat32( 24, true ),
        positionControlType: dv.getInt8( 28 ),
        positionUnits: dv.getInt8( 29 ),
        positionResolution: dv.getInt8( 30 ),
        travelDistance: dv.getFloat32( 31, true ),
        softStopRangePercent: dv.getUint8( 35 ),
    };
};

export const deserializeWritePositionControlSettingsResponse = ( dv: DataView ): IWritePositionControlSettingsResponse => {
    return {
        positionControlProportionalGain: dv.getFloat32( 4, true ),
        positionControlIntegralGain: dv.getFloat32( 8, true ),
        positionControlDerivGain: dv.getFloat32( 12, true ),
        positionControlMaxSpeed: dv.getFloat32( 16, true ),
        positionControlMaxAccel: dv.getFloat32( 20, true ),
        positionControlDeadband: dv.getFloat32( 24, true ),
        positionControlType: dv.getInt8( 28 ),
        positionUnits: dv.getInt8( 29 ),
        positionResolution: dv.getInt8( 30 ),
        travelDistance: dv.getFloat32( 31, true ),
        softStopRangePercent: dv.getUint8( 35 ),
    };
};

export const deserializeReadPositionControlSettingsRequest = ( dv: DataView ): IReadPositionControlSettingsRequest => {
    return {
    };
};

export const deserializeReadPositionControlSettingsResponse = ( dv: DataView ): IReadPositionControlSettingsResponse => {
    return {
        positionControlProportionalGain: dv.getFloat32( 4, true ),
        positionControlIntegralGain: dv.getFloat32( 8, true ),
        positionControlDerivGain: dv.getFloat32( 12, true ),
        positionControlMaxSpeed: dv.getFloat32( 16, true ),
        positionControlMaxAccel: dv.getFloat32( 20, true ),
        positionControlDeadband: dv.getFloat32( 24, true ),
        positionControlType: dv.getInt8( 28 ),
        positionUnits: dv.getInt8( 29 ),
        positionResolution: dv.getInt8( 30 ),
        travelDistance: dv.getFloat32( 31, true ),
        softStopRangePercent: dv.getUint8( 35 ),
    };
};

export const deserializeSetPositionSensorLimitsRequest = ( dv: DataView ): ISetPositionSensorLimitsRequest => {
    return {
        setCurrentPosToMin: dv.getUint8( 4 ),
        setCurrentPosToMax: dv.getUint8( 5 ),
        motorIndex: dv.getUint8( 6 ),
    };
};

export const deserializeSetPositionSensorLimitsResponse = ( dv: DataView ): ISetPositionSensorLimitsResponse => {
    return {
        minPosition: dv.getFloat32( 4, true ),
        maxPosition: dv.getFloat32( 8, true ),
    };
};

export const deserializeReadPositionSensorLimitsRequest = ( dv: DataView ): IReadPositionSensorLimitsRequest => {
    return {
    };
};

export const deserializeReadPositionSensorLimitsResponse = ( dv: DataView ): IReadPositionSensorLimitsResponse => {
    return {
        minValue: dv.getFloat32( 4, true ),
        maxValue: dv.getFloat32( 8, true ),
    };
};

export const deserializeStartHallSensorCalRequest = ( dv: DataView ): IStartHallSensorCalRequest => {
    return {
        motorIndex: dv.getUint8( 4 ),
    };
};

export const deserializeStartHallSensorCalResponse = ( dv: DataView ): IStartHallSensorCalResponse => {
    return {
    };
};

export const deserializeGetHallSensorCalResultRequest = ( dv: DataView ): IGetHallSensorCalResultRequest => {
    return {
    };
};

export const deserializeGetHallSensorCalResultResponse = ( dv: DataView ): IGetHallSensorCalResultResponse => {
    return {
        forwardOffset: dv.getFloat32( 4, true ),
        reverseOffset: dv.getFloat32( 8, true ),
        status: dv.getUint8( 12 ),
        direction: dv.getInt8( 13 ),
    };
};

export const deserializeHallSensorCalResultRequest = ( dv: DataView ): IHallSensorCalResultRequest => {
    return {
    };
};

export const deserializeHallSensorCalResultResponse = ( dv: DataView ): IHallSensorCalResultResponse => {
    return {
        forwardOffset: dv.getFloat32( 4, true ),
        reverseOffset: dv.getFloat32( 8, true ),
        status: dv.getUint8( 12 ),
        direction: dv.getInt8( 13 ),
    };
};

export const deserializeClearAllFaultsRequest = ( dv: DataView ): IClearAllFaultsRequest => {
    return {
    };
};

export const deserializeClearAllFaultsResponse = ( dv: DataView ): IClearAllFaultsResponse => {
    return {
    };
};

export const deserializeCertExchange1Request = ( dv: DataView ): ICertExchange1Request => {
    return {
        sLabCertFirstHalf: new Uint8Array( dv.buffer, 4, 50 ),
    };
};

export const deserializeCertExchange1Response = ( dv: DataView ): ICertExchange1Response => {
    return {
        mcuCertFirstHalf: new Uint8Array( dv.buffer, 4, 50 ),
    };
};

export const deserializeCertExchange2Request = ( dv: DataView ): ICertExchange2Request => {
    return {
        sLabCertLastHalf: new Uint8Array( dv.buffer, 4, 50 ),
    };
};

export const deserializeCertExchange2Response = ( dv: DataView ): ICertExchange2Response => {
    return {
        result: dv.getInt8( 4 ),
        mcuCertLastHalf: new Uint8Array( dv.buffer, 5, 50 ),
    };
};

export const deserializeEncChallenge1Request = ( dv: DataView ): IEncChallenge1Request => {
    return {
        challengeA: new Uint8Array( dv.buffer, 4, 16 ),
    };
};

export const deserializeEncChallenge1Response = ( dv: DataView ): IEncChallenge1Response => {
    return {
        encChallengeA: new Uint8Array( dv.buffer, 4, 16 ),
        challengeB: new Uint8Array( dv.buffer, 20, 16 ),
    };
};

export const deserializeEncChallenge2Request = ( dv: DataView ): IEncChallenge2Request => {
    return {
        encChallengeB: new Uint8Array( dv.buffer, 4, 16 ),
    };
};

export const deserializeEncChallenge2Response = ( dv: DataView ): IEncChallenge2Response => {
    return {
        result: dv.getInt8( 4 ),
    };
};

export const deserializeKeepAliveRequest = ( dv: DataView ): IKeepAliveRequest => {
    return {
    };
};

export const deserializeKeepAliveResponse = ( dv: DataView ): IKeepAliveResponse => {
    return {
        authStatus: dv.getInt8( 4 ),
    };
};

export const deserializeKeyConfigRequest = ( dv: DataView ): IKeyConfigRequest => {
    return {
        keyBytestream: new Uint8Array( dv.buffer, 4, 60 ),
    };
};

export const deserializeKeyConfigResponse = ( dv: DataView ): IKeyConfigResponse => {
    return {
        keyBytestreamRsp: new Uint8Array( dv.buffer, 4, 60 ),
    };
};

export const deserializeStartHomingCalRequest = ( dv: DataView ): IStartHomingCalRequest => {
    return {
    };
};

export const deserializeStartHomingCalResponse = ( dv: DataView ): IStartHomingCalResponse => {
    return {
    };
};

export const deserializeHomingCalResultRequest = ( dv: DataView ): IHomingCalResultRequest => {
    return {
    };
};

export const deserializeHomingCalResultResponse = ( dv: DataView ): IHomingCalResultResponse => {
    return {
        zeroOffset: dv.getFloat32( 4, true ),
        status: dv.getUint8( 8 ),
    };
};

export const deserializeStartSysidRequest = ( dv: DataView ): IStartSysidRequest => {
    return {
        motorIndex: dv.getUint8( 4 ),
    };
};

export const deserializeStartSysidResponse = ( dv: DataView ): IStartSysidResponse => {
    return {
    };
};

export const deserializeStopSysidRequest = ( dv: DataView ): IStopSysidRequest => {
    return {
    };
};

export const deserializeStopSysidResponse = ( dv: DataView ): IStopSysidResponse => {
    return {
    };
};

export const deserializeZeroDareSensorRequest = ( dv: DataView ): IZeroDareSensorRequest => {
    return {
    };
};

export const deserializeZeroDareSensorResponse = ( dv: DataView ): IZeroDareSensorResponse => {
    return {
        encoder0ZeroPos: dv.getUint16( 4, true ),
        encoder1ZeroPos: dv.getUint16( 6, true ),
    };
};

export const deserializeReadTotalActuatorsRequest = ( dv: DataView ): IReadTotalActuatorsRequest => {
    return {
    };
};

export const deserializeReadTotalActuatorsResponse = ( dv: DataView ): IReadTotalActuatorsResponse => {
    return {
        detectedNodes: dv.getUint8( 4 ),
        expectedNodes: dv.getUint8( 5 ),
        operationalNodesBitmap: dv.getUint32( 6, true ),
    };
};

export const deserializeActuatorInfoRequest = ( dv: DataView ): IActuatorInfoRequest => {
    return {
    };
};

export const deserializeActuatorInfoResponse = ( dv: DataView ): IActuatorInfoResponse => {
    return {
        nodeId: dv.getUint8( 4 ),
        dispositionStr: new Uint8Array( dv.buffer, 5, 27 ),
    };
};

export const deserializeSetControlModeRequest = ( dv: DataView ): ISetControlModeRequest => {
    return {
        controlMode: dv.getUint8( 4 ),
    };
};

export const deserializeSetControlModeResponse = ( dv: DataView ): ISetControlModeResponse => {
    return {
        controlMode: dv.getUint8( 4 ),
    };
};

export const deserializeEnableBulkTelemetryRequest = ( dv: DataView ): IEnableBulkTelemetryRequest => {
    return {
        enable: dv.getUint8( 4 ),
    };
};

export const deserializeEnableBulkTelemetryResponse = ( dv: DataView ): IEnableBulkTelemetryResponse => {
    return {
        enabled: dv.getUint8( 4 ),
    };
};

export const deserializeSetTelemRateRequest = ( dv: DataView ): ISetTelemRateRequest => {
    return {
        requestedHz: dv.getUint32( 4, true ),
    };
};

export const deserializeSetTelemRateResponse = ( dv: DataView ): ISetTelemRateResponse => {
    return {
        achievedHz: dv.getUint32( 4, true ),
    };
};

export const deserializeGetCapabilitiesRequest = ( dv: DataView ): IGetCapabilitiesRequest => {
    return {
    };
};

export const deserializeGetCapabilitiesResponse = ( dv: DataView ): IGetCapabilitiesResponse => {
    return {
        count: dv.getUint8( 4 ),
        entries: new Uint8Array( dv.buffer, 5, 59 ),
    };
};

export const deserializeAutotuneControlRequest = ( dv: DataView ): IAutotuneControlRequest => {
    return {
        motorIndex: dv.getUint8( 4 ),
        command: dv.getUint8( 5 ),
        targetPhase: dv.getUint8( 6 ),
    };
};

export const deserializeAutotuneControlResponse = ( dv: DataView ): IAutotuneControlResponse => {
    return {
        motorIndex: dv.getUint8( 4 ),
        status: dv.getUint8( 5 ),
        currentPhase: dv.getUint8( 6 ),
        errorCode: dv.getUint8( 7 ),
        xHalfSafeRad: dv.getFloat32( 8, true ),
        wFeasibleRadps: dv.getFloat32( 12, true ),
        alphaBrakeRadps2: dv.getFloat32( 16, true ),
        jAssumedKgm2: dv.getFloat32( 20, true ),
    };
};

export const deserializeGetAutotuneStatusRequest = ( dv: DataView ): IGetAutotuneStatusRequest => {
    return {
        motorIndex: dv.getUint8( 4 ),
    };
};

export const deserializeGetAutotuneStatusResponse = ( dv: DataView ): IGetAutotuneStatusResponse => {
    return {
        motorIndex: dv.getUint8( 4 ),
        status: dv.getUint8( 5 ),
        phase: dv.getUint8( 6 ),
        phaseProgress: dv.getUint8( 7 ),
        errorCode: dv.getUint8( 8 ),
        currentSpeedRadps: dv.getFloat32( 9, true ),
        currentTorqueNm: dv.getFloat32( 13, true ),
        currentPositionRad: dv.getFloat32( 17, true ),
        commandedSpeedRadps: dv.getFloat32( 21, true ),
        commandedTorqueNm: dv.getFloat32( 25, true ),
        identifiedJKgm2: dv.getFloat32( 29, true ),
        identifiedBNmsrad: dv.getFloat32( 33, true ),
        speedKp: dv.getFloat32( 37, true ),
        speedKi: dv.getFloat32( 41, true ),
        positionKp: dv.getFloat32( 45, true ),
        lastExitNextState: dv.getUint8( 49 ),
        lastExitReason: dv.getUint8( 50 ),
        lastExitPhase: dv.getUint8( 51 ),
        lastExitError: dv.getUint8( 52 ),
        lastExitTimeMs: dv.getUint32( 53, true ),
        safetyTripFlags: dv.getUint8( 57 ),
        idJFailReason: dv.getUint8( 58 ),
        jLatestTrialKgm2: dv.getFloat32( 59, true ),
        idBFailReason: dv.getUint8( 63 ),
    };
};

export const deserializeSetAutotuneConfigRequest = ( dv: DataView ): ISetAutotuneConfigRequest => {
    return {
        motorIndex: dv.getUint8( 4 ),
        maxCurrentA: dv.getFloat32( 5, true ),
        maxSpeedRadps: dv.getFloat32( 9, true ),
        maxAccelRadps2: dv.getFloat32( 13, true ),
        positionWindowRad: dv.getFloat32( 17, true ),
        speedBandwidthHz: dv.getFloat32( 21, true ),
        disturbanceRejectDb: dv.getFloat32( 25, true ),
        phaseMarginDeg: dv.getFloat32( 29, true ),
        positionBandwidthHz: dv.getFloat32( 33, true ),
        gearRatio: dv.getFloat32( 37, true ),
        ktNma: dv.getFloat32( 41, true ),
        polePairs: dv.getFloat32( 45, true ),
        zeroPlacementDivisor: dv.getFloat32( 49, true ),
        bootstrapRateLevel: dv.getUint8( 53 ),
        bootstrapMaxSpeedRadps: dv.getFloat32( 54, true ),
        skipBootstrap: dv.getUint8( 58 ),
    };
};

export const deserializeSetAutotuneConfigResponse = ( dv: DataView ): ISetAutotuneConfigResponse => {
    return {
        motorIndex: dv.getUint8( 4 ),
        status: dv.getUint8( 5 ),
    };
};

export const deserializeGetAutotuneParamsRequest = ( dv: DataView ): IGetAutotuneParamsRequest => {
    return {
        motorIndex: dv.getUint8( 4 ),
    };
};

export const deserializeGetAutotuneParamsResponse = ( dv: DataView ): IGetAutotuneParamsResponse => {
    return {
        motorIndex: dv.getUint8( 4 ),
        inertiaKgm2: dv.getFloat32( 5, true ),
        viscousFrictionNms: dv.getFloat32( 9, true ),
        coulombFrictionNm: dv.getFloat32( 13, true ),
        staticFrictionNm: dv.getFloat32( 17, true ),
        speedKp: dv.getFloat32( 21, true ),
        speedKi: dv.getFloat32( 25, true ),
        positionKp: dv.getFloat32( 29, true ),
        positionKi: dv.getFloat32( 33, true ),
        speedBandwidthHz: dv.getFloat32( 37, true ),
        speedPhaseMarginDeg: dv.getFloat32( 41, true ),
        speedSettlingTimeMs: dv.getFloat32( 45, true ),
        speedOvershootPct: dv.getFloat32( 49, true ),
        positionBandwidthHz: dv.getFloat32( 53, true ),
        positionSettlingTimeMs: dv.getFloat32( 57, true ),
    };
};

export const deserializeGetSensorCalStatusRequest = ( dv: DataView ): IGetSensorCalStatusRequest => {
    return {
        motorIndex: dv.getUint8( 4 ),
    };
};

export const deserializeGetSensorCalStatusResponse = ( dv: DataView ): IGetSensorCalStatusResponse => {
    return {
        motorIndex: dv.getUint8( 4 ),
        calStatus: dv.getUint8( 5 ),
        sampleCount: dv.getUint32( 6, true ),
        meanAngleErrorDeg: dv.getFloat32( 10, true ),
        stddevAngleErrorDeg: dv.getFloat32( 14, true ),
        sensorNoiseMeanDeg: dv.getFloat32( 18, true ),
        sensorNoiseStddevDeg: dv.getFloat32( 22, true ),
        dAxisOffsetRad: dv.getFloat32( 26, true ),
        lastAngleErrorDeg: dv.getFloat32( 30, true ),
    };
};

export const deserializeSetSeatMotionRequest = ( dv: DataView ): ISetSeatMotionRequest => {
    return {
        seat: dv.getUint8( 4 ),
        action: dv.getUint8( 5 ),
    };
};

export const deserializeSetSeatMotionResponse = ( dv: DataView ): ISetSeatMotionResponse => {
    return {
        seat: dv.getUint8( 4 ),
        action: dv.getUint8( 5 ),
        accepted: dv.getUint8( 6 ),
        state: dv.getUint8( 7 ),
    };
};

export const deserializeDeviceLogsRequest = ( dv: DataView ): IDeviceLogsRequest => {
    return {
        recordOffset: dv.getUint16( 4, true ),
        recordCount: dv.getUint16( 6, true ),
    };
};

export const deserializeDeviceLogsResponse = ( dv: DataView ): IDeviceLogsResponse => {
    return {
        recordNumber: dv.getUint32( 4, true ),
        msgSegment: new Uint8Array( dv.buffer, 8, 56 ),
    };
};

export const deserializeSetUsbThrottleControlRequest = ( dv: DataView ): ISetUsbThrottleControlRequest => {
    return {
        value: dv.getUint32( 4, true ),
        motorIndex: dv.getUint8( 8 ),
    };
};

export const deserializeSetUsbThrottleControlResponse = ( dv: DataView ): ISetUsbThrottleControlResponse => {
    return {
        value: dv.getUint32( 4, true ),
        motorIndex: dv.getUint8( 8 ),
    };
};

export const deserializeFaultDataMessage = ( dv: DataView ): IFaultDataMessage => {
    return {
        code: dv.getUint32( 4, true ),
    };
};

export const deserializeRealtimeDataMessage = ( dv: DataView ): IRealtimeDataMessage => {
    return {
        motorSpeed: dv.getFloat32( 4, true ),
        motorCurrent: dv.getFloat32( 8, true ),
        batteryVoltage: dv.getFloat32( 12, true ),
        batteryCurrent: dv.getFloat32( 16, true ),
        servoPulse: dv.getFloat32( 20, true ),
        inverterTemp: dv.getFloat32( 24, true ),
        controllerState: dv.getUint8( 28 ),
        faultCodeDeprecated: dv.getUint8( 29 ),
        uptimeMs: dv.getUint32( 30, true ),
        motorPosition: dv.getFloat32( 34, true ),
        positionSensorReading: dv.getFloat32( 38, true ),
        faultsBitmapLower32: dv.getUint32( 42, true ),
        faultsBitmapUpper16: dv.getUint16( 46, true ),
        externalThermTemp: dv.getFloat32( 48, true ),
        rawPositionSensor: dv.getFloat32( 52, true ),
        sysidFrequency: dv.getFloat32( 56, true ),
        sysidMagnitude: dv.getFloat32( 60, true ),
    };
};

export const deserializeVariableTelemetryMessage = ( dv: DataView ): IVariableTelemetryMessage => {
    return {
        telemId: dv.getUint8( 4 ),
        telemBytestream: new Uint8Array( dv.buffer, 5, 59 ),
    };
};

export const deserializeMultiMotorTelemetryMessage = ( dv: DataView ): IMultiMotorTelemetryMessage => {
    return {
        actuatorNodeId: dv.getUint8( 4 ),
        faultsBitmapLower32: dv.getUint32( 5, true ),
        faultsBitmapUpper16: dv.getUint16( 9, true ),
        positionActualPctOfRange: dv.getInt32( 11, true ),
        velocityActualValue: dv.getInt32( 15, true ),
        torqueActualValue: dv.getInt16( 19, true ),
        electricalCurrentActualValue: dv.getInt16( 21, true ),
        targetPositionPctOfRange: dv.getUint32( 23, true ),
        statusWord: dv.getUint16( 27, true ),
        mosfetTemperature: dv.getFloat32( 29, true ),
        batteryCurrent: dv.getFloat32( 33, true ),
        motorCurrent: dv.getFloat32( 37, true ),
        motorTemperature: dv.getFloat32( 41, true ),
        positionActualValue: dv.getFloat32( 45, true ),
        positionSensorRawValue: dv.getFloat32( 49, true ),
        positionUserUnits: dv.getFloat32( 53, true ),
    };
};

export const deserializeFirmwareUpdateRequest = ( dv: DataView ): IFirmwareUpdateRequest => {
    return {
    };
};

export const deserializeFirmwareUpdateResponse = ( dv: DataView ): IFirmwareUpdateResponse => {
    return {
    };
};

export const deserializeUserDefinedMessage = ( dv: DataView ): IUserDefinedMessage => {
    return {
    };
};

export const InvalidRequestFields = [
] as const;

export const InvalidResponseFields = [
] as const;

export const HandshakeRequestFields = [
] as const;

export const HandshakeResponseFields = [
    { name: 'versionMajor', type: 'uint32' },
    { name: 'versionMinor', type: 'uint32' },
    { name: 'versionBuild', type: 'uint32' },
    { name: 'resistance', type: 'float32' },
    { name: 'ld', type: 'float32' },
    { name: 'lq', type: 'float32' },
    { name: 'fluxLinkage', type: 'float32' },
    { name: 'gitHash', type: 'uint32' },
    { name: 'deviceId1', type: 'uint32' },
    { name: 'deviceId2', type: 'uint32' },
    { name: 'deviceId3', type: 'uint32' },
] as const;

export const StartParamDetectRequestFields = [
    { name: 'paramDetectMaxCurrent', type: 'float32' },
    { name: 'paramDetectMaxRpm', type: 'float32' },
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const StartParamDetectResponseFields = [
    { name: 'resistance', type: 'float32' },
    { name: 'ld', type: 'float32' },
    { name: 'lq', type: 'float32' },
    { name: 'fluxLinkage', type: 'float32' },
] as const;

export const WriteInputConfigRequestFields = [
    { name: 'inputLimitUpper', type: 'uint32' },
    { name: 'inputLimitLower', type: 'uint32' },
    { name: 'inputLimitCenter', type: 'uint32' },
    { name: 'inputMode', type: 'INPUT_MODE' },
    { name: 'alwaysOn', type: 'uint8' },
] as const;

export const WriteInputConfigResponseFields = [
    { name: 'inputLimitUpper', type: 'uint32' },
    { name: 'inputLimitLower', type: 'uint32' },
    { name: 'inputLimitCenter', type: 'uint32' },
    { name: 'inputMode', type: 'INPUT_MODE' },
    { name: 'alwaysOn', type: 'uint8' },
] as const;

export const WritePowerConfigRequestFields = [
    { name: 'motorCurrentLimit', type: 'float32' },
    { name: 'batteryCurrentLimit', type: 'float32' },
    { name: 'criticalOvervoltageThreshold', type: 'float32' },
    { name: 'criticalUndervoltageThreshold', type: 'float32' },
    { name: 'overcurrentThresholdDeprecated', type: 'float32' },
    { name: 'overtemperatureThreshold', type: 'float32' },
    { name: 'warningOvervoltageThreshold', type: 'float32' },
    { name: 'warningUndervoltageThreshold', type: 'float32' },
    { name: 'warningMotorCurrentThreshold', type: 'float32' },
    { name: 'criticalMotorCurrentThreshold', type: 'float32' },
] as const;

export const WritePowerConfigResponseFields = [
    { name: 'motorCurrentLimit', type: 'float32' },
    { name: 'batteryCurrentLimit', type: 'float32' },
    { name: 'criticalOvervoltageThreshold', type: 'float32' },
    { name: 'criticalUndervoltageThreshold', type: 'float32' },
    { name: 'overcurrentThresholdDeprecated', type: 'float32' },
    { name: 'overtemperatureThreshold', type: 'float32' },
    { name: 'warningOvervoltageThreshold', type: 'float32' },
    { name: 'warningUndervoltageThreshold', type: 'float32' },
    { name: 'warningMotorCurrentThreshold', type: 'float32' },
    { name: 'criticalMotorCurrentThreshold', type: 'float32' },
] as const;

export const ReadFaultRequestFields = [
] as const;

export const ReadFaultResponseFields = [
] as const;

export const ReadTelemetryRequestFields = [
] as const;

export const ReadTelemetryResponseFields = [
] as const;

export const ReadMotorParamRequestFields = [
] as const;

export const ReadMotorParamResponseFields = [
] as const;

export const ReadInputConfigRequestFields = [
] as const;

export const ReadInputConfigResponseFields = [
    { name: 'inputLimitUpper', type: 'uint32' },
    { name: 'inputLimitLower', type: 'uint32' },
    { name: 'inputLimitCenter', type: 'uint32' },
    { name: 'inputMode', type: 'INPUT_MODE' },
    { name: 'alwaysOn', type: 'uint8' },
] as const;

export const ReadPowerConfigRequestFields = [
] as const;

export const ReadPowerConfigResponseFields = [
    { name: 'motorCurrentLimit', type: 'float32' },
    { name: 'batteryCurrentLimit', type: 'float32' },
    { name: 'criticalOvervoltageThreshold', type: 'float32' },
    { name: 'criticalUndervoltageThreshold', type: 'float32' },
    { name: 'overcurrentThresholdDeprecated', type: 'float32' },
    { name: 'overtemperatureThreshold', type: 'float32' },
    { name: 'warningOvervoltageThreshold', type: 'float32' },
    { name: 'warningUndervoltageThreshold', type: 'float32' },
    { name: 'warningMotorCurrentThreshold', type: 'float32' },
    { name: 'criticalMotorCurrentThreshold', type: 'float32' },
] as const;

export const WriteParametersRequestFields = [
    { name: 'resistance', type: 'float32' },
    { name: 'ld', type: 'float32' },
    { name: 'lq', type: 'float32' },
    { name: 'fluxLinkage', type: 'float32' },
] as const;

export const WriteParametersResponseFields = [
    { name: 'resistance', type: 'float32' },
    { name: 'ld', type: 'float32' },
    { name: 'lq', type: 'float32' },
    { name: 'fluxLinkage', type: 'float32' },
] as const;

export const WriteControlConfigRequestFields = [
    { name: 'motorMaxSpeed', type: 'float32' },
    { name: 'polePairCount', type: 'float32' },
    { name: 'speedControlProportionalGain', type: 'float32' },
    { name: 'speedControlIntegralGain', type: 'float32' },
    { name: 'deprecatedPositionControlProportionalGain', type: 'float32' },
    { name: 'controlMode', type: 'CONTROL_MODE' },
    { name: 'mtpa', type: 'MTPA' },
    { name: 'fluxWeakening', type: 'FLUX_WEAKENING' },
] as const;

export const WriteControlConfigResponseFields = [
    { name: 'motorMaxSpeed', type: 'float32' },
    { name: 'polePairCount', type: 'float32' },
    { name: 'speedControlProportionalGain', type: 'float32' },
    { name: 'speedControlIntegralGain', type: 'float32' },
    { name: 'deprecatedPositionControlProportionalGain', type: 'float32' },
    { name: 'controlMode', type: 'CONTROL_MODE' },
    { name: 'mtpa', type: 'MTPA' },
    { name: 'fluxWeakening', type: 'FLUX_WEAKENING' },
] as const;

export const WriteSensorModeRequestFields = [
    { name: 'sensorMode', type: 'SENSOR_MODE' },
    { name: 'encoderCpr', type: 'uint32' },
] as const;

export const WriteSensorModeResponseFields = [
    { name: 'sensorMode', type: 'SENSOR_MODE' },
    { name: 'encoderCpr', type: 'uint32' },
] as const;

export const ReadSensorModeRequestFields = [
] as const;

export const ReadSensorModeResponseFields = [
    { name: 'sensorMode', type: 'SENSOR_MODE' },
    { name: 'encoderCpr', type: 'uint32' },
    { name: 'encoderOffset', type: 'float32' },
    { name: 'encoderDirection', type: 'ENCODER_DIRECTION' },
    { name: 'hallsensorForwardOffset', type: 'float32' },
    { name: 'hallsensorReverseOffset', type: 'float32' },
    { name: 'hallsensorDirection', type: 'HALLSENSOR_DIRECTION' },
] as const;

export const StartEncoderCalRequestFields = [
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const StartEncoderCalResponseFields = [
] as const;

export const GetEncoderCalResultRequestFields = [
] as const;

export const GetEncoderCalResultResponseFields = [
    { name: 'offset', type: 'float32' },
    { name: 'status', type: 'SENSOR_CALIB_STATUS' },
    { name: 'direction', type: 'ENCODER_DIRECTION' },
] as const;

export const EncoderCalResultRequestFields = [
] as const;

export const EncoderCalResultResponseFields = [
    { name: 'offset', type: 'float32' },
    { name: 'status', type: 'SENSOR_CALIB_STATUS' },
    { name: 'direction', type: 'ENCODER_DIRECTION' },
] as const;

export const WriteOpenLoopConfigRequestFields = [
    { name: 'accelerationRamp', type: 'float32' },
] as const;

export const WriteOpenLoopConfigResponseFields = [
    { name: 'accelerationRamp', type: 'float32' },
] as const;

export const ReadControlModeRequestFields = [
] as const;

export const ReadControlModeResponseFields = [
    { name: 'controlMode', type: 'CONTROL_MODE' },
] as const;

export const WriteCanIdRequestFields = [
    { name: 'canId', type: 'uint32' },
] as const;

export const WriteCanIdResponseFields = [
    { name: 'canId', type: 'uint32' },
] as const;

export const ReadCanIdRequestFields = [
] as const;

export const ReadCanIdResponseFields = [
    { name: 'canId', type: 'uint32' },
] as const;

export const WriteEscIdRequestFields = [
    { name: 'escIndex', type: 'uint32' },
] as const;

export const WriteEscIdResponseFields = [
    { name: 'escIndex', type: 'uint32' },
] as const;

export const ReadEscIdRequestFields = [
] as const;

export const ReadEscIdResponseFields = [
    { name: 'escIndex', type: 'uint32' },
] as const;

export const GetBuildInfoRequestFields = [
] as const;

export const GetBuildInfoResponseFields = [
    { name: 'year', type: 'uint32' },
    { name: 'month', type: 'uint32' },
    { name: 'day', type: 'uint32' },
    { name: 'increment', type: 'uint32' },
    { name: 'buildType', type: 'SM_FW_BUILD_TYPE' },
    { name: 'dirty', type: 'uint32' },
] as const;

export const ReadMtpaStatusRequestFields = [
] as const;

export const ReadMtpaStatusResponseFields = [
    { name: 'mtpa', type: 'MTPA' },
] as const;

export const ReadFluxWeakeningStatusRequestFields = [
] as const;

export const ReadFluxWeakeningStatusResponseFields = [
    { name: 'fluxWeakening', type: 'FLUX_WEAKENING' },
] as const;

export const WritePositionControlSettingsRequestFields = [
    { name: 'positionControlProportionalGain', type: 'float32' },
    { name: 'positionControlIntegralGain', type: 'float32' },
    { name: 'positionControlDerivGain', type: 'float32' },
    { name: 'positionControlMaxSpeed', type: 'float32' },
    { name: 'positionControlMaxAccel', type: 'float32' },
    { name: 'positionControlDeadband', type: 'float32' },
    { name: 'positionControlType', type: 'POSITION_TYPE' },
    { name: 'positionUnits', type: 'POSITION_UNITS' },
    { name: 'positionResolution', type: 'POSITION_RESOLUTION' },
    { name: 'travelDistance', type: 'float32' },
    { name: 'softStopRangePercent', type: 'uint8' },
] as const;

export const WritePositionControlSettingsResponseFields = [
    { name: 'positionControlProportionalGain', type: 'float32' },
    { name: 'positionControlIntegralGain', type: 'float32' },
    { name: 'positionControlDerivGain', type: 'float32' },
    { name: 'positionControlMaxSpeed', type: 'float32' },
    { name: 'positionControlMaxAccel', type: 'float32' },
    { name: 'positionControlDeadband', type: 'float32' },
    { name: 'positionControlType', type: 'POSITION_TYPE' },
    { name: 'positionUnits', type: 'POSITION_UNITS' },
    { name: 'positionResolution', type: 'POSITION_RESOLUTION' },
    { name: 'travelDistance', type: 'float32' },
    { name: 'softStopRangePercent', type: 'uint8' },
] as const;

export const ReadPositionControlSettingsRequestFields = [
] as const;

export const ReadPositionControlSettingsResponseFields = [
    { name: 'positionControlProportionalGain', type: 'float32' },
    { name: 'positionControlIntegralGain', type: 'float32' },
    { name: 'positionControlDerivGain', type: 'float32' },
    { name: 'positionControlMaxSpeed', type: 'float32' },
    { name: 'positionControlMaxAccel', type: 'float32' },
    { name: 'positionControlDeadband', type: 'float32' },
    { name: 'positionControlType', type: 'POSITION_TYPE' },
    { name: 'positionUnits', type: 'POSITION_UNITS' },
    { name: 'positionResolution', type: 'POSITION_RESOLUTION' },
    { name: 'travelDistance', type: 'float32' },
    { name: 'softStopRangePercent', type: 'uint8' },
] as const;

export const SetPositionSensorLimitsRequestFields = [
    { name: 'setCurrentPosToMin', type: 'uint8' },
    { name: 'setCurrentPosToMax', type: 'uint8' },
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const SetPositionSensorLimitsResponseFields = [
    { name: 'minPosition', type: 'float32' },
    { name: 'maxPosition', type: 'float32' },
] as const;

export const ReadPositionSensorLimitsRequestFields = [
] as const;

export const ReadPositionSensorLimitsResponseFields = [
    { name: 'minValue', type: 'float32' },
    { name: 'maxValue', type: 'float32' },
] as const;

export const StartHallSensorCalRequestFields = [
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const StartHallSensorCalResponseFields = [
] as const;

export const GetHallSensorCalResultRequestFields = [
] as const;

export const GetHallSensorCalResultResponseFields = [
    { name: 'forwardOffset', type: 'float32' },
    { name: 'reverseOffset', type: 'float32' },
    { name: 'status', type: 'SENSOR_CALIB_STATUS' },
    { name: 'direction', type: 'HALLSENSOR_DIRECTION' },
] as const;

export const HallSensorCalResultRequestFields = [
] as const;

export const HallSensorCalResultResponseFields = [
    { name: 'forwardOffset', type: 'float32' },
    { name: 'reverseOffset', type: 'float32' },
    { name: 'status', type: 'SENSOR_CALIB_STATUS' },
    { name: 'direction', type: 'HALLSENSOR_DIRECTION' },
] as const;

export const ClearAllFaultsRequestFields = [
] as const;

export const ClearAllFaultsResponseFields = [
] as const;

export const CertExchange1RequestFields = [
    { name: 'sLabCertFirstHalf', type: 'bytes(50)' },
] as const;

export const CertExchange1ResponseFields = [
    { name: 'mcuCertFirstHalf', type: 'bytes(50)' },
] as const;

export const CertExchange2RequestFields = [
    { name: 'sLabCertLastHalf', type: 'bytes(50)' },
] as const;

export const CertExchange2ResponseFields = [
    { name: 'result', type: 'CERT_EXCHANGE_RESULT' },
    { name: 'mcuCertLastHalf', type: 'bytes(50)' },
] as const;

export const EncChallenge1RequestFields = [
    { name: 'challengeA', type: 'bytes(16)' },
] as const;

export const EncChallenge1ResponseFields = [
    { name: 'encChallengeA', type: 'bytes(16)' },
    { name: 'challengeB', type: 'bytes(16)' },
] as const;

export const EncChallenge2RequestFields = [
    { name: 'encChallengeB', type: 'bytes(16)' },
] as const;

export const EncChallenge2ResponseFields = [
    { name: 'result', type: 'ENC_CHALLENGE_RESULT' },
] as const;

export const KeepAliveRequestFields = [
] as const;

export const KeepAliveResponseFields = [
    { name: 'authStatus', type: 'AUTH_STATUS' },
] as const;

export const KeyConfigRequestFields = [
    { name: 'keyBytestream', type: 'bytes(60)' },
] as const;

export const KeyConfigResponseFields = [
    { name: 'keyBytestreamRsp', type: 'bytes(60)' },
] as const;

export const StartHomingCalRequestFields = [
] as const;

export const StartHomingCalResponseFields = [
] as const;

export const HomingCalResultRequestFields = [
] as const;

export const HomingCalResultResponseFields = [
    { name: 'zeroOffset', type: 'float32' },
    { name: 'status', type: 'HOMING_CALIB_STATUS' },
] as const;

export const StartSysidRequestFields = [
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const StartSysidResponseFields = [
] as const;

export const StopSysidRequestFields = [
] as const;

export const StopSysidResponseFields = [
] as const;

export const ZeroDareSensorRequestFields = [
] as const;

export const ZeroDareSensorResponseFields = [
    { name: 'encoder0ZeroPos', type: 'uint16' },
    { name: 'encoder1ZeroPos', type: 'uint16' },
] as const;

export const ReadTotalActuatorsRequestFields = [
] as const;

export const ReadTotalActuatorsResponseFields = [
    { name: 'detectedNodes', type: 'uint8' },
    { name: 'expectedNodes', type: 'uint8' },
    { name: 'operationalNodesBitmap', type: 'uint32' },
] as const;

export const ActuatorInfoRequestFields = [
] as const;

export const ActuatorInfoResponseFields = [
    { name: 'nodeId', type: 'uint8' },
    { name: 'dispositionStr', type: 'bytes(27)' },
] as const;

export const SetControlModeRequestFields = [
    { name: 'controlMode', type: 'CONTROL_MODE' },
] as const;

export const SetControlModeResponseFields = [
    { name: 'controlMode', type: 'CONTROL_MODE' },
] as const;

export const EnableBulkTelemetryRequestFields = [
    { name: 'enable', type: 'uint8' },
] as const;

export const EnableBulkTelemetryResponseFields = [
    { name: 'enabled', type: 'uint8' },
] as const;

export const SetTelemRateRequestFields = [
    { name: 'requestedHz', type: 'uint32' },
] as const;

export const SetTelemRateResponseFields = [
    { name: 'achievedHz', type: 'uint32' },
] as const;

export const GetCapabilitiesRequestFields = [
] as const;

export const GetCapabilitiesResponseFields = [
    { name: 'count', type: 'uint8' },
    { name: 'entries', type: 'bytes(59)' },
] as const;

export const AutotuneControlRequestFields = [
    { name: 'motorIndex', type: 'uint8' },
    { name: 'command', type: 'AUTOTUNE_COMMAND' },
    { name: 'targetPhase', type: 'uint8' },
] as const;

export const AutotuneControlResponseFields = [
    { name: 'motorIndex', type: 'uint8' },
    { name: 'status', type: 'AUTOTUNE_STATUS' },
    { name: 'currentPhase', type: 'AUTOTUNE_PHASE' },
    { name: 'errorCode', type: 'AUTOTUNE_ERROR' },
    { name: 'xHalfSafeRad', type: 'float32' },
    { name: 'wFeasibleRadps', type: 'float32' },
    { name: 'alphaBrakeRadps2', type: 'float32' },
    { name: 'jAssumedKgm2', type: 'float32' },
] as const;

export const GetAutotuneStatusRequestFields = [
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const GetAutotuneStatusResponseFields = [
    { name: 'motorIndex', type: 'uint8' },
    { name: 'status', type: 'AUTOTUNE_STATUS' },
    { name: 'phase', type: 'AUTOTUNE_PHASE' },
    { name: 'phaseProgress', type: 'uint8' },
    { name: 'errorCode', type: 'AUTOTUNE_ERROR' },
    { name: 'currentSpeedRadps', type: 'float32' },
    { name: 'currentTorqueNm', type: 'float32' },
    { name: 'currentPositionRad', type: 'float32' },
    { name: 'commandedSpeedRadps', type: 'float32' },
    { name: 'commandedTorqueNm', type: 'float32' },
    { name: 'identifiedJKgm2', type: 'float32' },
    { name: 'identifiedBNmsrad', type: 'float32' },
    { name: 'speedKp', type: 'float32' },
    { name: 'speedKi', type: 'float32' },
    { name: 'positionKp', type: 'float32' },
    { name: 'lastExitNextState', type: 'uint8' },
    { name: 'lastExitReason', type: 'AUTOTUNE_EXIT_REASON' },
    { name: 'lastExitPhase', type: 'AUTOTUNE_PHASE' },
    { name: 'lastExitError', type: 'AUTOTUNE_ERROR' },
    { name: 'lastExitTimeMs', type: 'uint32' },
    { name: 'safetyTripFlags', type: 'uint8' },
    { name: 'idJFailReason', type: 'AUTOTUNE_ID_J_FAIL_REASON' },
    { name: 'jLatestTrialKgm2', type: 'float32' },
    { name: 'idBFailReason', type: 'AUTOTUNE_ID_B_FAIL_REASON' },
] as const;

export const SetAutotuneConfigRequestFields = [
    { name: 'motorIndex', type: 'uint8' },
    { name: 'maxCurrentA', type: 'float32' },
    { name: 'maxSpeedRadps', type: 'float32' },
    { name: 'maxAccelRadps2', type: 'float32' },
    { name: 'positionWindowRad', type: 'float32' },
    { name: 'speedBandwidthHz', type: 'float32' },
    { name: 'disturbanceRejectDb', type: 'float32' },
    { name: 'phaseMarginDeg', type: 'float32' },
    { name: 'positionBandwidthHz', type: 'float32' },
    { name: 'gearRatio', type: 'float32' },
    { name: 'ktNma', type: 'float32' },
    { name: 'polePairs', type: 'float32' },
    { name: 'zeroPlacementDivisor', type: 'float32' },
    { name: 'bootstrapRateLevel', type: 'uint8' },
    { name: 'bootstrapMaxSpeedRadps', type: 'float32' },
    { name: 'skipBootstrap', type: 'uint8' },
] as const;

export const SetAutotuneConfigResponseFields = [
    { name: 'motorIndex', type: 'uint8' },
    { name: 'status', type: 'uint8' },
] as const;

export const GetAutotuneParamsRequestFields = [
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const GetAutotuneParamsResponseFields = [
    { name: 'motorIndex', type: 'uint8' },
    { name: 'inertiaKgm2', type: 'float32' },
    { name: 'viscousFrictionNms', type: 'float32' },
    { name: 'coulombFrictionNm', type: 'float32' },
    { name: 'staticFrictionNm', type: 'float32' },
    { name: 'speedKp', type: 'float32' },
    { name: 'speedKi', type: 'float32' },
    { name: 'positionKp', type: 'float32' },
    { name: 'positionKi', type: 'float32' },
    { name: 'speedBandwidthHz', type: 'float32' },
    { name: 'speedPhaseMarginDeg', type: 'float32' },
    { name: 'speedSettlingTimeMs', type: 'float32' },
    { name: 'speedOvershootPct', type: 'float32' },
    { name: 'positionBandwidthHz', type: 'float32' },
    { name: 'positionSettlingTimeMs', type: 'float32' },
] as const;

export const GetSensorCalStatusRequestFields = [
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const GetSensorCalStatusResponseFields = [
    { name: 'motorIndex', type: 'uint8' },
    { name: 'calStatus', type: 'SENSOR_CALIB_STATUS' },
    { name: 'sampleCount', type: 'uint32' },
    { name: 'meanAngleErrorDeg', type: 'float32' },
    { name: 'stddevAngleErrorDeg', type: 'float32' },
    { name: 'sensorNoiseMeanDeg', type: 'float32' },
    { name: 'sensorNoiseStddevDeg', type: 'float32' },
    { name: 'dAxisOffsetRad', type: 'float32' },
    { name: 'lastAngleErrorDeg', type: 'float32' },
] as const;

export const SetSeatMotionRequestFields = [
    { name: 'seat', type: 'uint8' },
    { name: 'action', type: 'SEAT_ACTION' },
] as const;

export const SetSeatMotionResponseFields = [
    { name: 'seat', type: 'uint8' },
    { name: 'action', type: 'SEAT_ACTION' },
    { name: 'accepted', type: 'uint8' },
    { name: 'state', type: 'SEAT_STATE' },
] as const;

export const DeviceLogsRequestFields = [
    { name: 'recordOffset', type: 'uint16' },
    { name: 'recordCount', type: 'uint16' },
] as const;

export const DeviceLogsResponseFields = [
    { name: 'recordNumber', type: 'uint32' },
    { name: 'msgSegment', type: 'bytes(56)' },
] as const;

export const SetUsbThrottleControlRequestFields = [
    { name: 'value', type: 'uint32' },
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const SetUsbThrottleControlResponseFields = [
    { name: 'value', type: 'uint32' },
    { name: 'motorIndex', type: 'uint8' },
] as const;

export const FaultDataMessageFields = [
    { name: 'code', type: 'uint32' },
] as const;

export const RealtimeDataMessageFields = [
    { name: 'motorSpeed', type: 'float32' },
    { name: 'motorCurrent', type: 'float32' },
    { name: 'batteryVoltage', type: 'float32' },
    { name: 'batteryCurrent', type: 'float32' },
    { name: 'servoPulse', type: 'float32' },
    { name: 'inverterTemp', type: 'float32' },
    { name: 'controllerState', type: 'CONTROLLER_STATE' },
    { name: 'faultCodeDeprecated', type: 'FAULT_CODE' },
    { name: 'uptimeMs', type: 'uint32' },
    { name: 'motorPosition', type: 'float32' },
    { name: 'positionSensorReading', type: 'float32' },
    { name: 'faultsBitmapLower32', type: 'uint32' },
    { name: 'faultsBitmapUpper16', type: 'uint16' },
    { name: 'externalThermTemp', type: 'float32' },
    { name: 'rawPositionSensor', type: 'float32' },
    { name: 'sysidFrequency', type: 'float32' },
    { name: 'sysidMagnitude', type: 'float32' },
] as const;

export const VariableTelemetryMessageFields = [
    { name: 'telemId', type: 'uint8' },
    { name: 'telemBytestream', type: 'bytes(59)' },
] as const;

export const MultiMotorTelemetryMessageFields = [
    { name: 'actuatorNodeId', type: 'uint8' },
    { name: 'faultsBitmapLower32', type: 'uint32' },
    { name: 'faultsBitmapUpper16', type: 'uint16' },
    { name: 'positionActualPctOfRange', type: 'int32' },
    { name: 'velocityActualValue', type: 'int32' },
    { name: 'torqueActualValue', type: 'int16' },
    { name: 'electricalCurrentActualValue', type: 'int16' },
    { name: 'targetPositionPctOfRange', type: 'uint32' },
    { name: 'statusWord', type: 'uint16' },
    { name: 'mosfetTemperature', type: 'float32' },
    { name: 'batteryCurrent', type: 'float32' },
    { name: 'motorCurrent', type: 'float32' },
    { name: 'motorTemperature', type: 'float32' },
    { name: 'positionActualValue', type: 'float32' },
    { name: 'positionSensorRawValue', type: 'float32' },
    { name: 'positionUserUnits', type: 'float32' },
] as const;

export const FirmwareUpdateRequestFields = [
] as const;

export const FirmwareUpdateResponseFields = [
] as const;

export const UserDefinedMessageFields = [
] as const;

export interface IReceivedPacketTypes {
    [ PacketId.INVALID ]: IInvalidResponse;
    [ PacketId.HANDSHAKE ]: IHandshakeResponse;
    [ PacketId.START_PARAM_DETECT ]: IStartParamDetectResponse;
    [ PacketId.WRITE_INPUT_CONFIG ]: IWriteInputConfigResponse;
    [ PacketId.WRITE_POWER_CONFIG ]: IWritePowerConfigResponse;
    [ PacketId.READ_FAULT ]: IReadFaultResponse;
    [ PacketId.READ_TELEMETRY ]: IReadTelemetryResponse;
    [ PacketId.READ_MOTOR_PARAM ]: IReadMotorParamResponse;
    [ PacketId.READ_INPUT_CONFIG ]: IReadInputConfigResponse;
    [ PacketId.READ_POWER_CONFIG ]: IReadPowerConfigResponse;
    [ PacketId.WRITE_PARAMETERS ]: IWriteParametersResponse;
    [ PacketId.WRITE_CONTROL_CONFIG ]: IWriteControlConfigResponse;
    [ PacketId.WRITE_SENSOR_MODE ]: IWriteSensorModeResponse;
    [ PacketId.READ_SENSOR_MODE ]: IReadSensorModeResponse;
    [ PacketId.START_ENCODER_CAL ]: IStartEncoderCalResponse;
    [ PacketId.GET_ENCODER_CAL_RESULT ]: IGetEncoderCalResultResponse;
    [ PacketId.ENCODER_CAL_RESULT ]: IEncoderCalResultResponse;
    [ PacketId.WRITE_OPEN_LOOP_CONFIG ]: IWriteOpenLoopConfigResponse;
    [ PacketId.READ_CONTROL_MODE ]: IReadControlModeResponse;
    [ PacketId.WRITE_CAN_ID ]: IWriteCanIdResponse;
    [ PacketId.READ_CAN_ID ]: IReadCanIdResponse;
    [ PacketId.WRITE_ESC_ID ]: IWriteEscIdResponse;
    [ PacketId.READ_ESC_ID ]: IReadEscIdResponse;
    [ PacketId.GET_BUILD_INFO ]: IGetBuildInfoResponse;
    [ PacketId.READ_MTPA_STATUS ]: IReadMtpaStatusResponse;
    [ PacketId.READ_FLUX_WEAKENING_STATUS ]: IReadFluxWeakeningStatusResponse;
    [ PacketId.WRITE_POSITION_CONTROL_SETTINGS ]: IWritePositionControlSettingsResponse;
    [ PacketId.READ_POSITION_CONTROL_SETTINGS ]: IReadPositionControlSettingsResponse;
    [ PacketId.SET_POSITION_SENSOR_LIMITS ]: ISetPositionSensorLimitsResponse;
    [ PacketId.READ_POSITION_SENSOR_LIMITS ]: IReadPositionSensorLimitsResponse;
    [ PacketId.START_HALL_SENSOR_CAL ]: IStartHallSensorCalResponse;
    [ PacketId.GET_HALL_SENSOR_CAL_RESULT ]: IGetHallSensorCalResultResponse;
    [ PacketId.HALL_SENSOR_CAL_RESULT ]: IHallSensorCalResultResponse;
    [ PacketId.CLEAR_ALL_FAULTS ]: IClearAllFaultsResponse;
    [ PacketId.CERT_EXCHANGE_1 ]: ICertExchange1Response;
    [ PacketId.CERT_EXCHANGE_2 ]: ICertExchange2Response;
    [ PacketId.ENC_CHALLENGE_1 ]: IEncChallenge1Response;
    [ PacketId.ENC_CHALLENGE_2 ]: IEncChallenge2Response;
    [ PacketId.KEEP_ALIVE ]: IKeepAliveResponse;
    [ PacketId.KEY_CONFIG ]: IKeyConfigResponse;
    [ PacketId.START_HOMING_CAL ]: IStartHomingCalResponse;
    [ PacketId.HOMING_CAL_RESULT ]: IHomingCalResultResponse;
    [ PacketId.START_SYSID ]: IStartSysidResponse;
    [ PacketId.STOP_SYSID ]: IStopSysidResponse;
    [ PacketId.ZERO_DARE_SENSOR ]: IZeroDareSensorResponse;
    [ PacketId.READ_TOTAL_ACTUATORS ]: IReadTotalActuatorsResponse;
    [ PacketId.ACTUATOR_INFO ]: IActuatorInfoResponse;
    [ PacketId.SET_CONTROL_MODE ]: ISetControlModeResponse;
    [ PacketId.ENABLE_BULK_TELEMETRY ]: IEnableBulkTelemetryResponse;
    [ PacketId.SET_TELEM_RATE ]: ISetTelemRateResponse;
    [ PacketId.GET_CAPABILITIES ]: IGetCapabilitiesResponse;
    [ PacketId.AUTOTUNE_CONTROL ]: IAutotuneControlResponse;
    [ PacketId.GET_AUTOTUNE_STATUS ]: IGetAutotuneStatusResponse;
    [ PacketId.SET_AUTOTUNE_CONFIG ]: ISetAutotuneConfigResponse;
    [ PacketId.GET_AUTOTUNE_PARAMS ]: IGetAutotuneParamsResponse;
    [ PacketId.GET_SENSOR_CAL_STATUS ]: IGetSensorCalStatusResponse;
    [ PacketId.SET_SEAT_MOTION ]: ISetSeatMotionResponse;
    [ PacketId.DEVICE_LOGS ]: IDeviceLogsResponse;
    [ PacketId.SET_USB_THROTTLE_CONTROL ]: ISetUsbThrottleControlResponse;
    [ PacketId.FAULT_DATA ]: IFaultDataMessage;
    [ PacketId.REALTIME_DATA ]: IRealtimeDataMessage;
    [ PacketId.VARIABLE_TELEMETRY ]: IVariableTelemetryMessage;
    [ PacketId.MULTI_MOTOR_TELEMETRY ]: IMultiMotorTelemetryMessage;
    [ PacketId.FIRMWARE_UPDATE ]: IFirmwareUpdateResponse;
    [ PacketId.USER_DEFINED ]: IUserDefinedMessage;
}

export type PacketKeys<I extends PacketId> = keyof IReceivedPacketTypes[ I ];

type DisplayUnits = { [ I in PacketId ]: { [ K in PacketKeys<I> ]: string } };
export const displayUnits: DisplayUnits = {
    [ PacketId.INVALID ]: {
    },
    [ PacketId.HANDSHAKE ]: {
        versionMajor: "",
        versionMinor: "",
        versionBuild: "",
        resistance: "ohms",
        ld: "H",
        lq: "H",
        fluxLinkage: "Wb",
        gitHash: "",
        deviceId1: "",
        deviceId2: "",
        deviceId3: "",
    },
    [ PacketId.START_PARAM_DETECT ]: {
        resistance: "ohms",
        ld: "H",
        lq: "H",
        fluxLinkage: "Wb",
    },
    [ PacketId.WRITE_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.WRITE_POWER_CONFIG ]: {
        motorCurrentLimit: "A",
        batteryCurrentLimit: "A",
        criticalOvervoltageThreshold: "V",
        criticalUndervoltageThreshold: "V",
        overcurrentThresholdDeprecated: "A",
        overtemperatureThreshold: "°C",
        warningOvervoltageThreshold: "V",
        warningUndervoltageThreshold: "V",
        warningMotorCurrentThreshold: "A",
        criticalMotorCurrentThreshold: "A",
    },
    [ PacketId.READ_FAULT ]: {
    },
    [ PacketId.READ_TELEMETRY ]: {
    },
    [ PacketId.READ_MOTOR_PARAM ]: {
    },
    [ PacketId.READ_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.READ_POWER_CONFIG ]: {
        motorCurrentLimit: "A",
        batteryCurrentLimit: "A",
        criticalOvervoltageThreshold: "V",
        criticalUndervoltageThreshold: "V",
        overcurrentThresholdDeprecated: "A",
        overtemperatureThreshold: "°C",
        warningOvervoltageThreshold: "V",
        warningUndervoltageThreshold: "V",
        warningMotorCurrentThreshold: "A",
        criticalMotorCurrentThreshold: "A",
    },
    [ PacketId.WRITE_PARAMETERS ]: {
        resistance: "ohms",
        ld: "H",
        lq: "H",
        fluxLinkage: "Wb",
    },
    [ PacketId.WRITE_CONTROL_CONFIG ]: {
        motorMaxSpeed: "rad/s",
        polePairCount: "",
        speedControlProportionalGain: "Nm/(mrad/s)",
        speedControlIntegralGain: "N-m/rad",
        deprecatedPositionControlProportionalGain: "",
        controlMode: "",
        mtpa: "",
        fluxWeakening: "",
    },
    [ PacketId.WRITE_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
    },
    [ PacketId.READ_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
        encoderOffset: "mrads",
        encoderDirection: "",
        hallsensorForwardOffset: "",
        hallsensorReverseOffset: "",
        hallsensorDirection: "",
    },
    [ PacketId.START_ENCODER_CAL ]: {
    },
    [ PacketId.GET_ENCODER_CAL_RESULT ]: {
        offset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.ENCODER_CAL_RESULT ]: {
        offset: "mrads",
        status: "",
        direction: "",
    },
    [ PacketId.WRITE_OPEN_LOOP_CONFIG ]: {
        accelerationRamp: "erad/s^2",
    },
    [ PacketId.READ_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.WRITE_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.READ_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.WRITE_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.READ_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.GET_BUILD_INFO ]: {
        year: "",
        month: "",
        day: "",
        increment: "",
        buildType: "",
        dirty: "",
    },
    [ PacketId.READ_MTPA_STATUS ]: {
        mtpa: "",
    },
    [ PacketId.READ_FLUX_WEAKENING_STATUS ]: {
        fluxWeakening: "",
    },
    [ PacketId.WRITE_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
        softStopRangePercent: "%",
    },
    [ PacketId.READ_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
        softStopRangePercent: "%",
    },
    [ PacketId.SET_POSITION_SENSOR_LIMITS ]: {
        minPosition: "rad",
        maxPosition: "rad",
    },
    [ PacketId.READ_POSITION_SENSOR_LIMITS ]: {
        minValue: "",
        maxValue: "",
    },
    [ PacketId.START_HALL_SENSOR_CAL ]: {
    },
    [ PacketId.GET_HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "radians",
        reverseOffset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "radians",
        reverseOffset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.CLEAR_ALL_FAULTS ]: {
    },
    [ PacketId.CERT_EXCHANGE_1 ]: {
        mcuCertFirstHalf: "",
    },
    [ PacketId.CERT_EXCHANGE_2 ]: {
        result: "",
        mcuCertLastHalf: "",
    },
    [ PacketId.ENC_CHALLENGE_1 ]: {
        encChallengeA: "",
        challengeB: "",
    },
    [ PacketId.ENC_CHALLENGE_2 ]: {
        result: "",
    },
    [ PacketId.KEEP_ALIVE ]: {
        authStatus: "",
    },
    [ PacketId.KEY_CONFIG ]: {
        keyBytestreamRsp: "",
    },
    [ PacketId.START_HOMING_CAL ]: {
    },
    [ PacketId.HOMING_CAL_RESULT ]: {
        zeroOffset: "radians",
        status: "",
    },
    [ PacketId.START_SYSID ]: {
    },
    [ PacketId.STOP_SYSID ]: {
    },
    [ PacketId.ZERO_DARE_SENSOR ]: {
        encoder0ZeroPos: "",
        encoder1ZeroPos: "",
    },
    [ PacketId.READ_TOTAL_ACTUATORS ]: {
        detectedNodes: "",
        expectedNodes: "",
        operationalNodesBitmap: "",
    },
    [ PacketId.ACTUATOR_INFO ]: {
        nodeId: "",
        dispositionStr: "",
    },
    [ PacketId.SET_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.ENABLE_BULK_TELEMETRY ]: {
        enabled: "",
    },
    [ PacketId.SET_TELEM_RATE ]: {
        achievedHz: "",
    },
    [ PacketId.GET_CAPABILITIES ]: {
        count: "",
        entries: "",
    },
    [ PacketId.AUTOTUNE_CONTROL ]: {
        motorIndex: "",
        status: "",
        currentPhase: "",
        errorCode: "",
        xHalfSafeRad: "rad",
        wFeasibleRadps: "rad/s",
        alphaBrakeRadps2: "rad/s^2",
        jAssumedKgm2: "kg.m^2",
    },
    [ PacketId.GET_AUTOTUNE_STATUS ]: {
        motorIndex: "",
        status: "",
        phase: "",
        phaseProgress: "",
        errorCode: "",
        currentSpeedRadps: "rad/s",
        currentTorqueNm: "N.m",
        currentPositionRad: "rad",
        commandedSpeedRadps: "rad/s",
        commandedTorqueNm: "N.m",
        identifiedJKgm2: "kg.m^2",
        identifiedBNmsrad: "N.m.s/rad",
        speedKp: "",
        speedKi: "",
        positionKp: "",
        lastExitNextState: "",
        lastExitReason: "",
        lastExitPhase: "",
        lastExitError: "",
        lastExitTimeMs: "ms",
        safetyTripFlags: "",
        idJFailReason: "",
        jLatestTrialKgm2: "kg.m^2",
        idBFailReason: "",
    },
    [ PacketId.SET_AUTOTUNE_CONFIG ]: {
        motorIndex: "",
        status: "",
    },
    [ PacketId.GET_AUTOTUNE_PARAMS ]: {
        motorIndex: "",
        inertiaKgm2: "kg.m^2",
        viscousFrictionNms: "N.m.s",
        coulombFrictionNm: "N.m",
        staticFrictionNm: "N.m",
        speedKp: "",
        speedKi: "",
        positionKp: "",
        positionKi: "",
        speedBandwidthHz: "Hz",
        speedPhaseMarginDeg: "deg",
        speedSettlingTimeMs: "ms",
        speedOvershootPct: "%",
        positionBandwidthHz: "Hz",
        positionSettlingTimeMs: "ms",
    },
    [ PacketId.GET_SENSOR_CAL_STATUS ]: {
        motorIndex: "",
        calStatus: "",
        sampleCount: "",
        meanAngleErrorDeg: "deg",
        stddevAngleErrorDeg: "deg",
        sensorNoiseMeanDeg: "deg",
        sensorNoiseStddevDeg: "deg",
        dAxisOffsetRad: "rad",
        lastAngleErrorDeg: "deg",
    },
    [ PacketId.SET_SEAT_MOTION ]: {
        seat: "",
        action: "",
        accepted: "",
        state: "",
    },
    [ PacketId.DEVICE_LOGS ]: {
        recordNumber: "",
        msgSegment: "",
    },
    [ PacketId.SET_USB_THROTTLE_CONTROL ]: {
        value: "",
        motorIndex: "",
    },
    [ PacketId.FAULT_DATA ]: {
        code: "",
    },
    [ PacketId.REALTIME_DATA ]: {
        motorSpeed: "RPM",
        motorCurrent: "A",
        batteryVoltage: "V",
        batteryCurrent: "A",
        servoPulse: "",
        inverterTemp: "°C",
        controllerState: "",
        faultCodeDeprecated: "",
        uptimeMs: "ms",
        motorPosition: "radians",
        positionSensorReading: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        externalThermTemp: "°C",
        rawPositionSensor: "",
        sysidFrequency: "Hz",
        sysidMagnitude: "",
    },
    [ PacketId.VARIABLE_TELEMETRY ]: {
        telemId: "",
        telemBytestream: "",
    },
    [ PacketId.MULTI_MOTOR_TELEMETRY ]: {
        actuatorNodeId: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        positionActualPctOfRange: "",
        velocityActualValue: "RPM",
        torqueActualValue: "Nm",
        electricalCurrentActualValue: "mA",
        targetPositionPctOfRange: "",
        statusWord: "",
        mosfetTemperature: "°C",
        batteryCurrent: "A",
        motorCurrent: "A",
        motorTemperature: "°C",
        positionActualValue: "mrad",
        positionSensorRawValue: "counts",
        positionUserUnits: "user units",
    },
    [ PacketId.FIRMWARE_UPDATE ]: {
    },
    [ PacketId.USER_DEFINED ]: {
    },
};

export const fullDisplayUnits: DisplayUnits = {
    [ PacketId.INVALID ]: {
    },
    [ PacketId.HANDSHAKE ]: {
        versionMajor: "",
        versionMinor: "",
        versionBuild: "",
        resistance: "ohms",
        ld: "henry",
        lq: "henry",
        fluxLinkage: "weber",
        gitHash: "",
        deviceId1: "",
        deviceId2: "",
        deviceId3: "",
    },
    [ PacketId.START_PARAM_DETECT ]: {
        resistance: "ohms",
        ld: "henry",
        lq: "henry",
        fluxLinkage: "weber",
    },
    [ PacketId.WRITE_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.WRITE_POWER_CONFIG ]: {
        motorCurrentLimit: "amps",
        batteryCurrentLimit: "amps",
        criticalOvervoltageThreshold: "volts",
        criticalUndervoltageThreshold: "volts",
        overcurrentThresholdDeprecated: "amps",
        overtemperatureThreshold: "celsius",
        warningOvervoltageThreshold: "volts",
        warningUndervoltageThreshold: "volts",
        warningMotorCurrentThreshold: "amps",
        criticalMotorCurrentThreshold: "amps",
    },
    [ PacketId.READ_FAULT ]: {
    },
    [ PacketId.READ_TELEMETRY ]: {
    },
    [ PacketId.READ_MOTOR_PARAM ]: {
    },
    [ PacketId.READ_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.READ_POWER_CONFIG ]: {
        motorCurrentLimit: "amps",
        batteryCurrentLimit: "amps",
        criticalOvervoltageThreshold: "volts",
        criticalUndervoltageThreshold: "volts",
        overcurrentThresholdDeprecated: "amps",
        overtemperatureThreshold: "celsius",
        warningOvervoltageThreshold: "volts",
        warningUndervoltageThreshold: "volts",
        warningMotorCurrentThreshold: "amps",
        criticalMotorCurrentThreshold: "amps",
    },
    [ PacketId.WRITE_PARAMETERS ]: {
        resistance: "ohms",
        ld: "henry",
        lq: "henry",
        fluxLinkage: "weber",
    },
    [ PacketId.WRITE_CONTROL_CONFIG ]: {
        motorMaxSpeed: "mechanical rad/s",
        polePairCount: "",
        speedControlProportionalGain: "Newton-meter-second per mechanical radian",
        speedControlIntegralGain: "Newton-meter per radian",
        deprecatedPositionControlProportionalGain: "",
        controlMode: "",
        mtpa: "",
        fluxWeakening: "",
    },
    [ PacketId.WRITE_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
    },
    [ PacketId.READ_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
        encoderOffset: "Mechanical radians",
        encoderDirection: "",
        hallsensorForwardOffset: "",
        hallsensorReverseOffset: "",
        hallsensorDirection: "",
    },
    [ PacketId.START_ENCODER_CAL ]: {
    },
    [ PacketId.GET_ENCODER_CAL_RESULT ]: {
        offset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.ENCODER_CAL_RESULT ]: {
        offset: "Mechanical radians",
        status: "",
        direction: "",
    },
    [ PacketId.WRITE_OPEN_LOOP_CONFIG ]: {
        accelerationRamp: "electrical radians per second squared",
    },
    [ PacketId.READ_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.WRITE_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.READ_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.WRITE_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.READ_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.GET_BUILD_INFO ]: {
        year: "",
        month: "",
        day: "",
        increment: "",
        buildType: "",
        dirty: "",
    },
    [ PacketId.READ_MTPA_STATUS ]: {
        mtpa: "",
    },
    [ PacketId.READ_FLUX_WEAKENING_STATUS ]: {
        fluxWeakening: "",
    },
    [ PacketId.WRITE_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
        softStopRangePercent: "%",
    },
    [ PacketId.READ_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
        softStopRangePercent: "%",
    },
    [ PacketId.SET_POSITION_SENSOR_LIMITS ]: {
        minPosition: "radians",
        maxPosition: "radians",
    },
    [ PacketId.READ_POSITION_SENSOR_LIMITS ]: {
        minValue: "",
        maxValue: "",
    },
    [ PacketId.START_HALL_SENSOR_CAL ]: {
    },
    [ PacketId.GET_HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "radians",
        reverseOffset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "radians",
        reverseOffset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.CLEAR_ALL_FAULTS ]: {
    },
    [ PacketId.CERT_EXCHANGE_1 ]: {
        mcuCertFirstHalf: "",
    },
    [ PacketId.CERT_EXCHANGE_2 ]: {
        result: "",
        mcuCertLastHalf: "",
    },
    [ PacketId.ENC_CHALLENGE_1 ]: {
        encChallengeA: "",
        challengeB: "",
    },
    [ PacketId.ENC_CHALLENGE_2 ]: {
        result: "",
    },
    [ PacketId.KEEP_ALIVE ]: {
        authStatus: "",
    },
    [ PacketId.KEY_CONFIG ]: {
        keyBytestreamRsp: "",
    },
    [ PacketId.START_HOMING_CAL ]: {
    },
    [ PacketId.HOMING_CAL_RESULT ]: {
        zeroOffset: "radians",
        status: "",
    },
    [ PacketId.START_SYSID ]: {
    },
    [ PacketId.STOP_SYSID ]: {
    },
    [ PacketId.ZERO_DARE_SENSOR ]: {
        encoder0ZeroPos: "",
        encoder1ZeroPos: "",
    },
    [ PacketId.READ_TOTAL_ACTUATORS ]: {
        detectedNodes: "",
        expectedNodes: "",
        operationalNodesBitmap: "",
    },
    [ PacketId.ACTUATOR_INFO ]: {
        nodeId: "",
        dispositionStr: "",
    },
    [ PacketId.SET_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.ENABLE_BULK_TELEMETRY ]: {
        enabled: "",
    },
    [ PacketId.SET_TELEM_RATE ]: {
        achievedHz: "",
    },
    [ PacketId.GET_CAPABILITIES ]: {
        count: "",
        entries: "",
    },
    [ PacketId.AUTOTUNE_CONTROL ]: {
        motorIndex: "",
        status: "",
        currentPhase: "",
        errorCode: "",
        xHalfSafeRad: "",
        wFeasibleRadps: "",
        alphaBrakeRadps2: "",
        jAssumedKgm2: "",
    },
    [ PacketId.GET_AUTOTUNE_STATUS ]: {
        motorIndex: "",
        status: "",
        phase: "",
        phaseProgress: "",
        errorCode: "",
        currentSpeedRadps: "",
        currentTorqueNm: "",
        currentPositionRad: "",
        commandedSpeedRadps: "",
        commandedTorqueNm: "",
        identifiedJKgm2: "",
        identifiedBNmsrad: "",
        speedKp: "",
        speedKi: "",
        positionKp: "",
        lastExitNextState: "",
        lastExitReason: "",
        lastExitPhase: "",
        lastExitError: "",
        lastExitTimeMs: "",
        safetyTripFlags: "",
        idJFailReason: "",
        jLatestTrialKgm2: "",
        idBFailReason: "",
    },
    [ PacketId.SET_AUTOTUNE_CONFIG ]: {
        motorIndex: "",
        status: "",
    },
    [ PacketId.GET_AUTOTUNE_PARAMS ]: {
        motorIndex: "",
        inertiaKgm2: "",
        viscousFrictionNms: "",
        coulombFrictionNm: "",
        staticFrictionNm: "",
        speedKp: "",
        speedKi: "",
        positionKp: "",
        positionKi: "",
        speedBandwidthHz: "",
        speedPhaseMarginDeg: "",
        speedSettlingTimeMs: "",
        speedOvershootPct: "",
        positionBandwidthHz: "",
        positionSettlingTimeMs: "",
    },
    [ PacketId.GET_SENSOR_CAL_STATUS ]: {
        motorIndex: "",
        calStatus: "",
        sampleCount: "",
        meanAngleErrorDeg: "Degrees",
        stddevAngleErrorDeg: "Degrees",
        sensorNoiseMeanDeg: "Degrees",
        sensorNoiseStddevDeg: "Degrees",
        dAxisOffsetRad: "Radians",
        lastAngleErrorDeg: "Degrees",
    },
    [ PacketId.SET_SEAT_MOTION ]: {
        seat: "",
        action: "",
        accepted: "",
        state: "",
    },
    [ PacketId.DEVICE_LOGS ]: {
        recordNumber: "",
        msgSegment: "",
    },
    [ PacketId.SET_USB_THROTTLE_CONTROL ]: {
        value: "",
        motorIndex: "",
    },
    [ PacketId.FAULT_DATA ]: {
        code: "",
    },
    [ PacketId.REALTIME_DATA ]: {
        motorSpeed: "RPM",
        motorCurrent: "amps",
        batteryVoltage: "volts",
        batteryCurrent: "amps",
        servoPulse: "",
        inverterTemp: "celsius",
        controllerState: "",
        faultCodeDeprecated: "",
        uptimeMs: "",
        motorPosition: "",
        positionSensorReading: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        externalThermTemp: "celsius",
        rawPositionSensor: "",
        sysidFrequency: "Hz",
        sysidMagnitude: "",
    },
    [ PacketId.VARIABLE_TELEMETRY ]: {
        telemId: "",
        telemBytestream: "",
    },
    [ PacketId.MULTI_MOTOR_TELEMETRY ]: {
        actuatorNodeId: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        positionActualPctOfRange: "1/10,000ths",
        velocityActualValue: "RPM",
        torqueActualValue: "Newton-meters",
        electricalCurrentActualValue: "milliamps",
        targetPositionPctOfRange: "1/10,000ths",
        statusWord: "",
        mosfetTemperature: "celsius",
        batteryCurrent: "amps",
        motorCurrent: "amps",
        motorTemperature: "celsius",
        positionActualValue: "mrad",
        positionSensorRawValue: "counts",
        positionUserUnits: "user units",
    },
    [ PacketId.FIRMWARE_UPDATE ]: {
    },
    [ PacketId.USER_DEFINED ]: {
    },
};

type DisplayColors = { [ I in PacketId ]: { [ K in PacketKeys<I> ]: string } };
export const displayColors: DisplayColors = {
    [ PacketId.INVALID ]: {
    },
    [ PacketId.HANDSHAKE ]: {
        versionMajor: "",
        versionMinor: "",
        versionBuild: "",
        resistance: "",
        ld: "",
        lq: "",
        fluxLinkage: "",
        gitHash: "",
        deviceId1: "",
        deviceId2: "",
        deviceId3: "",
    },
    [ PacketId.START_PARAM_DETECT ]: {
        resistance: "",
        ld: "",
        lq: "",
        fluxLinkage: "",
    },
    [ PacketId.WRITE_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.WRITE_POWER_CONFIG ]: {
        motorCurrentLimit: "",
        batteryCurrentLimit: "",
        criticalOvervoltageThreshold: "",
        criticalUndervoltageThreshold: "",
        overcurrentThresholdDeprecated: "",
        overtemperatureThreshold: "",
        warningOvervoltageThreshold: "",
        warningUndervoltageThreshold: "",
        warningMotorCurrentThreshold: "",
        criticalMotorCurrentThreshold: "",
    },
    [ PacketId.READ_FAULT ]: {
    },
    [ PacketId.READ_TELEMETRY ]: {
    },
    [ PacketId.READ_MOTOR_PARAM ]: {
    },
    [ PacketId.READ_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.READ_POWER_CONFIG ]: {
        motorCurrentLimit: "",
        batteryCurrentLimit: "",
        criticalOvervoltageThreshold: "",
        criticalUndervoltageThreshold: "",
        overcurrentThresholdDeprecated: "",
        overtemperatureThreshold: "",
        warningOvervoltageThreshold: "",
        warningUndervoltageThreshold: "",
        warningMotorCurrentThreshold: "",
        criticalMotorCurrentThreshold: "",
    },
    [ PacketId.WRITE_PARAMETERS ]: {
        resistance: "",
        ld: "",
        lq: "",
        fluxLinkage: "",
    },
    [ PacketId.WRITE_CONTROL_CONFIG ]: {
        motorMaxSpeed: "",
        polePairCount: "",
        speedControlProportionalGain: "",
        speedControlIntegralGain: "",
        deprecatedPositionControlProportionalGain: "",
        controlMode: "",
        mtpa: "",
        fluxWeakening: "",
    },
    [ PacketId.WRITE_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
    },
    [ PacketId.READ_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
        encoderOffset: "",
        encoderDirection: "",
        hallsensorForwardOffset: "",
        hallsensorReverseOffset: "",
        hallsensorDirection: "",
    },
    [ PacketId.START_ENCODER_CAL ]: {
    },
    [ PacketId.GET_ENCODER_CAL_RESULT ]: {
        offset: "",
        status: "",
        direction: "",
    },
    [ PacketId.ENCODER_CAL_RESULT ]: {
        offset: "",
        status: "",
        direction: "",
    },
    [ PacketId.WRITE_OPEN_LOOP_CONFIG ]: {
        accelerationRamp: "",
    },
    [ PacketId.READ_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.WRITE_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.READ_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.WRITE_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.READ_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.GET_BUILD_INFO ]: {
        year: "",
        month: "",
        day: "",
        increment: "",
        buildType: "",
        dirty: "",
    },
    [ PacketId.READ_MTPA_STATUS ]: {
        mtpa: "",
    },
    [ PacketId.READ_FLUX_WEAKENING_STATUS ]: {
        fluxWeakening: "",
    },
    [ PacketId.WRITE_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
        softStopRangePercent: "",
    },
    [ PacketId.READ_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
        softStopRangePercent: "",
    },
    [ PacketId.SET_POSITION_SENSOR_LIMITS ]: {
        minPosition: "",
        maxPosition: "",
    },
    [ PacketId.READ_POSITION_SENSOR_LIMITS ]: {
        minValue: "",
        maxValue: "",
    },
    [ PacketId.START_HALL_SENSOR_CAL ]: {
    },
    [ PacketId.GET_HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "",
        reverseOffset: "",
        status: "",
        direction: "",
    },
    [ PacketId.HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "",
        reverseOffset: "",
        status: "",
        direction: "",
    },
    [ PacketId.CLEAR_ALL_FAULTS ]: {
    },
    [ PacketId.CERT_EXCHANGE_1 ]: {
        mcuCertFirstHalf: "",
    },
    [ PacketId.CERT_EXCHANGE_2 ]: {
        result: "",
        mcuCertLastHalf: "",
    },
    [ PacketId.ENC_CHALLENGE_1 ]: {
        encChallengeA: "",
        challengeB: "",
    },
    [ PacketId.ENC_CHALLENGE_2 ]: {
        result: "",
    },
    [ PacketId.KEEP_ALIVE ]: {
        authStatus: "",
    },
    [ PacketId.KEY_CONFIG ]: {
        keyBytestreamRsp: "",
    },
    [ PacketId.START_HOMING_CAL ]: {
    },
    [ PacketId.HOMING_CAL_RESULT ]: {
        zeroOffset: "",
        status: "",
    },
    [ PacketId.START_SYSID ]: {
    },
    [ PacketId.STOP_SYSID ]: {
    },
    [ PacketId.ZERO_DARE_SENSOR ]: {
        encoder0ZeroPos: "",
        encoder1ZeroPos: "",
    },
    [ PacketId.READ_TOTAL_ACTUATORS ]: {
        detectedNodes: "",
        expectedNodes: "",
        operationalNodesBitmap: "",
    },
    [ PacketId.ACTUATOR_INFO ]: {
        nodeId: "",
        dispositionStr: "",
    },
    [ PacketId.SET_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.ENABLE_BULK_TELEMETRY ]: {
        enabled: "",
    },
    [ PacketId.SET_TELEM_RATE ]: {
        achievedHz: "",
    },
    [ PacketId.GET_CAPABILITIES ]: {
        count: "",
        entries: "",
    },
    [ PacketId.AUTOTUNE_CONTROL ]: {
        motorIndex: "",
        status: "",
        currentPhase: "",
        errorCode: "",
        xHalfSafeRad: "",
        wFeasibleRadps: "",
        alphaBrakeRadps2: "",
        jAssumedKgm2: "",
    },
    [ PacketId.GET_AUTOTUNE_STATUS ]: {
        motorIndex: "",
        status: "",
        phase: "",
        phaseProgress: "",
        errorCode: "",
        currentSpeedRadps: "",
        currentTorqueNm: "",
        currentPositionRad: "",
        commandedSpeedRadps: "",
        commandedTorqueNm: "",
        identifiedJKgm2: "",
        identifiedBNmsrad: "",
        speedKp: "",
        speedKi: "",
        positionKp: "",
        lastExitNextState: "",
        lastExitReason: "",
        lastExitPhase: "",
        lastExitError: "",
        lastExitTimeMs: "",
        safetyTripFlags: "",
        idJFailReason: "",
        jLatestTrialKgm2: "",
        idBFailReason: "",
    },
    [ PacketId.SET_AUTOTUNE_CONFIG ]: {
        motorIndex: "",
        status: "",
    },
    [ PacketId.GET_AUTOTUNE_PARAMS ]: {
        motorIndex: "",
        inertiaKgm2: "",
        viscousFrictionNms: "",
        coulombFrictionNm: "",
        staticFrictionNm: "",
        speedKp: "",
        speedKi: "",
        positionKp: "",
        positionKi: "",
        speedBandwidthHz: "",
        speedPhaseMarginDeg: "",
        speedSettlingTimeMs: "",
        speedOvershootPct: "",
        positionBandwidthHz: "",
        positionSettlingTimeMs: "",
    },
    [ PacketId.GET_SENSOR_CAL_STATUS ]: {
        motorIndex: "",
        calStatus: "",
        sampleCount: "",
        meanAngleErrorDeg: "",
        stddevAngleErrorDeg: "",
        sensorNoiseMeanDeg: "",
        sensorNoiseStddevDeg: "",
        dAxisOffsetRad: "",
        lastAngleErrorDeg: "",
    },
    [ PacketId.SET_SEAT_MOTION ]: {
        seat: "",
        action: "",
        accepted: "",
        state: "",
    },
    [ PacketId.DEVICE_LOGS ]: {
        recordNumber: "",
        msgSegment: "",
    },
    [ PacketId.SET_USB_THROTTLE_CONTROL ]: {
        value: "",
        motorIndex: "",
    },
    [ PacketId.FAULT_DATA ]: {
        code: "",
    },
    [ PacketId.REALTIME_DATA ]: {
        motorSpeed: "#f74943",
        motorCurrent: "#f7faa2",
        batteryVoltage: "#2cded8",
        batteryCurrent: "#8d8df0",
        servoPulse: "#efc0fc",
        inverterTemp: "#faa114",
        controllerState: "",
        faultCodeDeprecated: "",
        uptimeMs: "#3dba5b",
        motorPosition: "#9105a3",
        positionSensorReading: "#b169ff",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        externalThermTemp: "#c28d9f",
        rawPositionSensor: "#86da40",
        sysidFrequency: "#00ff00",
        sysidMagnitude: "#ffff00",
    },
    [ PacketId.VARIABLE_TELEMETRY ]: {
        telemId: "",
        telemBytestream: "",
    },
    [ PacketId.MULTI_MOTOR_TELEMETRY ]: {
        actuatorNodeId: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        positionActualPctOfRange: "",
        velocityActualValue: "",
        torqueActualValue: "",
        electricalCurrentActualValue: "",
        targetPositionPctOfRange: "",
        statusWord: "",
        mosfetTemperature: "",
        batteryCurrent: "",
        motorCurrent: "",
        motorTemperature: "",
        positionActualValue: "",
        positionSensorRawValue: "",
        positionUserUnits: "",
    },
    [ PacketId.FIRMWARE_UPDATE ]: {
    },
    [ PacketId.USER_DEFINED ]: {
    },
};

export const inputReportID = ( dv: DataView ): PacketId => {
    return dv.getUint8( 0 );
};

export const deserialize = ( dv: DataView ): IReceivedPacketTypes[ PacketId ] => {
    switch ( inputReportID( dv ) ) {
        case PacketId.INVALID: return deserializeInvalidResponse( dv );
        case PacketId.HANDSHAKE: return deserializeHandshakeResponse( dv );
        case PacketId.START_PARAM_DETECT: return deserializeStartParamDetectResponse( dv );
        case PacketId.WRITE_INPUT_CONFIG: return deserializeWriteInputConfigResponse( dv );
        case PacketId.WRITE_POWER_CONFIG: return deserializeWritePowerConfigResponse( dv );
        case PacketId.READ_FAULT: return deserializeReadFaultResponse( dv );
        case PacketId.READ_TELEMETRY: return deserializeReadTelemetryResponse( dv );
        case PacketId.READ_MOTOR_PARAM: return deserializeReadMotorParamResponse( dv );
        case PacketId.READ_INPUT_CONFIG: return deserializeReadInputConfigResponse( dv );
        case PacketId.READ_POWER_CONFIG: return deserializeReadPowerConfigResponse( dv );
        case PacketId.WRITE_PARAMETERS: return deserializeWriteParametersResponse( dv );
        case PacketId.WRITE_CONTROL_CONFIG: return deserializeWriteControlConfigResponse( dv );
        case PacketId.WRITE_SENSOR_MODE: return deserializeWriteSensorModeResponse( dv );
        case PacketId.READ_SENSOR_MODE: return deserializeReadSensorModeResponse( dv );
        case PacketId.START_ENCODER_CAL: return deserializeStartEncoderCalResponse( dv );
        case PacketId.GET_ENCODER_CAL_RESULT: return deserializeGetEncoderCalResultResponse( dv );
        case PacketId.ENCODER_CAL_RESULT: return deserializeEncoderCalResultResponse( dv );
        case PacketId.WRITE_OPEN_LOOP_CONFIG: return deserializeWriteOpenLoopConfigResponse( dv );
        case PacketId.READ_CONTROL_MODE: return deserializeReadControlModeResponse( dv );
        case PacketId.WRITE_CAN_ID: return deserializeWriteCanIdResponse( dv );
        case PacketId.READ_CAN_ID: return deserializeReadCanIdResponse( dv );
        case PacketId.WRITE_ESC_ID: return deserializeWriteEscIdResponse( dv );
        case PacketId.READ_ESC_ID: return deserializeReadEscIdResponse( dv );
        case PacketId.GET_BUILD_INFO: return deserializeGetBuildInfoResponse( dv );
        case PacketId.READ_MTPA_STATUS: return deserializeReadMtpaStatusResponse( dv );
        case PacketId.READ_FLUX_WEAKENING_STATUS: return deserializeReadFluxWeakeningStatusResponse( dv );
        case PacketId.WRITE_POSITION_CONTROL_SETTINGS: return deserializeWritePositionControlSettingsResponse( dv );
        case PacketId.READ_POSITION_CONTROL_SETTINGS: return deserializeReadPositionControlSettingsResponse( dv );
        case PacketId.SET_POSITION_SENSOR_LIMITS: return deserializeSetPositionSensorLimitsResponse( dv );
        case PacketId.READ_POSITION_SENSOR_LIMITS: return deserializeReadPositionSensorLimitsResponse( dv );
        case PacketId.START_HALL_SENSOR_CAL: return deserializeStartHallSensorCalResponse( dv );
        case PacketId.GET_HALL_SENSOR_CAL_RESULT: return deserializeGetHallSensorCalResultResponse( dv );
        case PacketId.HALL_SENSOR_CAL_RESULT: return deserializeHallSensorCalResultResponse( dv );
        case PacketId.CLEAR_ALL_FAULTS: return deserializeClearAllFaultsResponse( dv );
        case PacketId.CERT_EXCHANGE_1: return deserializeCertExchange1Response( dv );
        case PacketId.CERT_EXCHANGE_2: return deserializeCertExchange2Response( dv );
        case PacketId.ENC_CHALLENGE_1: return deserializeEncChallenge1Response( dv );
        case PacketId.ENC_CHALLENGE_2: return deserializeEncChallenge2Response( dv );
        case PacketId.KEEP_ALIVE: return deserializeKeepAliveResponse( dv );
        case PacketId.KEY_CONFIG: return deserializeKeyConfigResponse( dv );
        case PacketId.START_HOMING_CAL: return deserializeStartHomingCalResponse( dv );
        case PacketId.HOMING_CAL_RESULT: return deserializeHomingCalResultResponse( dv );
        case PacketId.START_SYSID: return deserializeStartSysidResponse( dv );
        case PacketId.STOP_SYSID: return deserializeStopSysidResponse( dv );
        case PacketId.ZERO_DARE_SENSOR: return deserializeZeroDareSensorResponse( dv );
        case PacketId.READ_TOTAL_ACTUATORS: return deserializeReadTotalActuatorsResponse( dv );
        case PacketId.ACTUATOR_INFO: return deserializeActuatorInfoResponse( dv );
        case PacketId.SET_CONTROL_MODE: return deserializeSetControlModeResponse( dv );
        case PacketId.ENABLE_BULK_TELEMETRY: return deserializeEnableBulkTelemetryResponse( dv );
        case PacketId.SET_TELEM_RATE: return deserializeSetTelemRateResponse( dv );
        case PacketId.GET_CAPABILITIES: return deserializeGetCapabilitiesResponse( dv );
        case PacketId.AUTOTUNE_CONTROL: return deserializeAutotuneControlResponse( dv );
        case PacketId.GET_AUTOTUNE_STATUS: return deserializeGetAutotuneStatusResponse( dv );
        case PacketId.SET_AUTOTUNE_CONFIG: return deserializeSetAutotuneConfigResponse( dv );
        case PacketId.GET_AUTOTUNE_PARAMS: return deserializeGetAutotuneParamsResponse( dv );
        case PacketId.GET_SENSOR_CAL_STATUS: return deserializeGetSensorCalStatusResponse( dv );
        case PacketId.SET_SEAT_MOTION: return deserializeSetSeatMotionResponse( dv );
        case PacketId.DEVICE_LOGS: return deserializeDeviceLogsResponse( dv );
        case PacketId.SET_USB_THROTTLE_CONTROL: return deserializeSetUsbThrottleControlResponse( dv );
        case PacketId.FAULT_DATA: return deserializeFaultDataMessage( dv );
        case PacketId.REALTIME_DATA: return deserializeRealtimeDataMessage( dv );
        case PacketId.VARIABLE_TELEMETRY: return deserializeVariableTelemetryMessage( dv );
        case PacketId.MULTI_MOTOR_TELEMETRY: return deserializeMultiMotorTelemetryMessage( dv );
        case PacketId.FIRMWARE_UPDATE: return deserializeFirmwareUpdateResponse( dv );
        case PacketId.USER_DEFINED: return deserializeUserDefinedMessage( dv );
    }
};
